// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:20.575Z
// Property: The Residences at Bluhawk Apartment Homes (ID: 6767906449167619)
// Collections: 27 amenities, 6 floorplans (live), 39 photos, 76 POIs, 4 reviews, 6 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167619",
  "property_external_id": "1106358",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-residences-at-bluhawk-apartment-homes-overland-park-ks/h67b3y2/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1106358 p1081360",
  "property_status": null,
  "property_slug": "the-residences-at-bluhawk-apartment-homes",
  "property_name": "The Residences at Bluhawk Apartment Homes",
  "property_website_url": "https://www.theresidencesatbluhawk.com/",
  "property_domain": "https://www.theresidencesatbluhawk.com/",
  "property_address": "16611 Lowell Ave",
  "property_full_address": "16611 Lowell Ave #2202, Overland Park, KS 66085",
  "property_address_1": "16611 Lowell Ave",
  "property_address_2": "2202",
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66085",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Outlying Johnson County KS",
  "property_address_latitude": "38.8266469",
  "property_address_longitude": "-94.6793363",
  "property_email": "RentCafe.BH@PriceKC.com",
  "property_phone": "(913) 578-8101",
  "property_call_tracking_phone": "913-578-8101",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Live where South Overland Park comes alive.</strong> The Residences at Bluhawk pairs spacious one-, two-, and three-bedroom homes with polished finishes, everyday convenience, and on-site comforts—all inside the Bluhawk shopping and entertainment development.</p>",
  "property_long_description": "<p>Welcome to The Residences at Bluhawk, a premier apartment community in Overland Park, Kansas, situated within the heart of the Bluhawk Entertainment and Shopping Development. Offering one-, two-, and three-bedroom apartment homes ranging from 787 to 1,563 square feet, The Residences at Bluhawk delivers an elevated standard of living without sacrificing the convenience and connectivity you need every day.</p><p>From the moment you arrive, the details set The Residences at Bluhawk apart. Enjoy a gourmet coffee and hot tea bar to start your mornings, challenge friends to a game on the pickleball court, and enjoy the on-site playground. Garages and carports are available for covered parking, and the Hawk Flock Membership Program adds special perks to everyday life. Inside your home, you will find a full-size washer and dryer, 9-foot ceilings, custom wood cabinetry, gourmet kitchen finishes, and a private patio or balcony.</p><p>Browse floor plans, explore our amenities, or reach out to our leasing team to find your next home at The Residences at Bluhawk.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-5e8b-70b3-9264-c652403c6385.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with island and stainless steel appliances",
    "public_id": "01a0b671-5e8b-70b3-9264-c652403c6385",
    "storage_key": "property/6767906449167619/01a0b671-5e8b-70b3-9264-c652403c6385.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "201",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.03482587064677",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://theresidencesatbluhawk.securecafeapplicant.com/onlineleasing/content3/access/the-residences-at-bluhawk/floorplans",
  "property_resident_portal_url": "https://theresidencesatbluhawk.securecafe.com/residentservices/the-residences-at-bluhawk/userlogin.aspx",
  "property_apply_now_url": "https://theresidencesatbluhawk.securecafeapplicant.com/onlineleasing/content3/access/the-residences-at-bluhawk/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-c51e-76d5-a9f5-3a7d15844f41.webp",
  "property_primary_logo_media": {
    "alt_text": "The Residences at Bluhawk logo",
    "public_id": "019fc98c-c51e-76d5-a9f5-3a7d15844f41",
    "storage_key": "property/6767906449167619/019fc98c-c51e-76d5-a9f5-3a7d15844f41.webp",
    "width": 2265,
    "height": 387
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a19e19-ab04-74bc-aa40-e5577c828331.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Residences at BluHawk logo",
    "public_id": "01a19e19-ab04-74bc-aa40-e5577c828331",
    "storage_key": "property/6767906449167619/01a19e19-ab04-74bc-aa40-e5577c828331.webp",
    "width": 1920,
    "height": 328
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-c51e-76d5-a9f5-3a7d15844f41.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Residences at Bluhawk logo",
    "public_id": "019fc98c-c51e-76d5-a9f5-3a7d15844f41",
    "storage_key": "property/6767906449167619/019fc98c-c51e-76d5-a9f5-3a7d15844f41.webp",
    "width": 2265,
    "height": 387
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#98AA87",
  "property_secondary_color": "#7D99AA",
  "property_font_color": null,
  "property_color_4": "#132820",
  "property_color_3": "#B7CBCB",
  "property_color_5": "#263D3D",
  "property_color_6": "#4A665C",
  "property_color_7": "#567580",
  "property_color_8": "#597A89",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "787 - 1563",
  "property_sqft_min": "787",
  "property_sqft_max": "1563",
  "property_price_range": "1313 - 8284",
  "property_price_min": "1313",
  "property_price_max": "8284",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/ResidencesAtBluhawk",
  "property_instagram_url": "https://www.instagram.com/residencesatbluhawk/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJhSEqG13BwIcR4xtoFAmWAAM",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Residences at Bluhawk Apartment Homes",
  "property_home_romance_title": "Embrace the Joy of Living at Our Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> Grab coffee or hot tea on-site, rally on the pickleball court, fire up the courtyard grills, or host overnight visitors in the short-term guest suite. Hawk Flock perks connect the community to participating Bluhawk businesses, while online services and on-site maintenance simplify the essentials. Inside, granite countertops, stainless steel appliances, full-size laundry, smart thermostats, and select patios or balconies add everyday polish.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Bluhawk.</strong> Choose from one-, two-, and three-bedroom floor plans with open living spaces, gourmet kitchens, granite countertops, stainless steel appliances, custom wood cabinetry, and stylish lighting. Select homes add private patios or balconies, while everyday conveniences like full-size washers and dryers, large closets, nine-foot ceilings, and smart thermostats make each layout feel polished and practical.</p>",
  "property_home_gallery_blurb": "<p><strong>See Bluhawk living in full color.</strong> Preview kitchens with granite counters, custom wood cabinetry, stainless steel appliances, and pendant lighting, then look for open living spaces filled with natural light. The gallery also captures inviting community perks, from the coffee and hot tea bar to the grill courtyard and pickleball court—all near shopping, dining, and entertainment in Overland Park.</p>",
  "property_home_neighborhood_blurb": "<p>The Residences at Bluhawk is located at 16611 Lowell Avenue in Overland Park, Kansas, within the Bluhawk retail and entertainment corridor near Highway 69 and 167th Street. Dining, shopping, and everyday essentials are right nearby. AdventHealth South Overland Park, Cosentino’s Food Store, Ironhorse Golf Club, and T.J. Maxx are all minutes away.</p><p>The Residences at Bluhawk is located within the Blue Valley School District. Downtown Overland Park and the broader Kansas City metro are accessible via Highway 69, making it easy to get around the area.</p><p>Discover more restaurants, shopping, parks, and destinations on our <a href=\"/neighborhood\">Neighborhood page</a>.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Bluhawk stands out</strong> for modern finishes, spacious layouts, natural light, smart storage, and quality appliances that make home feel effortless. Reviews also highlight attentive management, fast and friendly maintenance, community events, and easy access to shopping, dining, parks, and trails. See why residents describe The Residences at Bluhawk as a “wonderful place to live.”</p>",
  "property_neighborhood_blurb": "<p>The Residences at Bluhawk is located at 16611 Lowell Avenue in Overland Park, KS, inside the Bluhawk shopping and entertainment development near 167th Street and US-69. Shopping, dining, and everyday errands are a short walk or drive from home.</p><p>Looking for a place to eat near The Residences at Bluhawk? Our team recommends Red Door Woodfired Grill, Gyu-Kaku Japanese BBQ, and JINYA Ramen Bar, all inside the Bluhawk development. For shopping, Bluhawk’s shops include Sierra, with T.J. Maxx and Cosentino’s Food Store close by for errands and groceries.</p><p>AdventHealth South Overland Park is minutes from The Residences at Bluhawk, and Ironhorse Golf Club is nearby for a round of golf. The community is in the Blue Valley School District, and US-69 connects residents to Downtown Overland Park and the greater Kansas City metro.</p><p>Explore the neighborhood map above to find more destinations near The Residences at Bluhawk.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>The Residences at Bluhawk is one of the few Overland Park apartment communities with an on-site pickleball court. Residents also have a coffee and hot tea bar, a courtyard, a playground, and a guest suite that visiting family and friends can rent for short stays.</p><p>Does The Residences at Bluhawk have a gym and pool? Through an official partnership with C26 Hub Gym and Pool, residents get reservation-based gym access, pool access, and two group fitness classes a week. The Hawk Flock VIP program adds perks at businesses inside the Bluhawk development, including complimentary public ice skating and open fieldhouse time at AdventHealth Sports Park at Bluhawk, 50% off gaming at LEVELUP, and discounts at JINYA Ramen Bar, SaladWorks, and Brutus Barkery + Bath.</p><p>Looking for Overland Park apartments with garages? The Residences at Bluhawk offers garages and carports for covered parking, along with flexible rent payment options and professional on-site management.</p><p>Every apartment at The Residences at Bluhawk includes 9-foot ceilings, a gourmet kitchen with custom wood cabinetry, stainless steel appliances, a full-size washer and dryer, and ceiling fans. Select homes add a custom tile shower, upgraded lighting, or a programmable thermostat. Cats and dogs are welcome. See our <a href=\"/pet-policy\">pet policy</a> for details.</p><p>Explore the full amenity list above.</p>",
  "property_applynow_blurb": "<p><strong>Start your application with confidence.</strong> The Residences at Bluhawk Apartment Homes brings spacious one-, two-, and three-bedroom living to South Overland Park, with granite countertops, stainless steel appliances, full-size washers and dryers, and select private patios or balconies—all connected to everyday dining, shopping, and recreation.</p>",
  "property_contactus_blurb": "<p>Have a question about The Residences at Bluhawk? Connect with our leasing team for information about apartment availability, <a href=\"/floor-plans\">floor plans</a>, community <a href=\"/amenities\">amenities</a>, leasing terms, or upcoming <a href=\"/schedule-a-tour\">tours</a>.</p><p>Visit us in person at 16611 Lowell Avenue in Overland Park, Kansas, give us a call at <a href=\"tel:+19135788101\">(913) 578-8101</a>, or complete the contact form above. Our team is happy to help you explore available floor plans and find your new home at The Residences at Bluhawk.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Residences at Bluhawk?</strong> Start here. This FAQ covers common details about the community, leasing, pet-friendly living, floor plans, amenities, and everyday conveniences. If you don’t see what you need, the on-site leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>At The Residences at Bluhawk in Overland Park, Kansas, we offer a variety of one-, two-, and three-bedroom floor plans ranging from 787 to 1,563 square feet. Whether you are looking for a smart one-bedroom layout or a generously sized three-bedroom apartment home, The Residences at Bluhawk has a floor plan designed around the way you live.</p><p>Every apartment at The Residences at Bluhawk features 9-foot ceilings, gourmet kitchens with custom wood cabinetry, stainless steel appliances, and stylish track and pendant lighting. Full-size washer and dryer are included in every home. Select floor plans offer additional finishes such as custom tile showers, faux wood blinds, programmable digital thermostats, and private patios or balconies with scenic community views.</p><p>The Residences at Bluhawk is one of the newer apartment communities in Overland Park, offering modern design and high-end finishes within the Bluhawk Entertainment and Shopping Development. Residents also have access to garages and carports for covered parking, a community playground, pickleball court, and gourmet coffee bar.</p><p>Browse available floor plans above and <a href=\"/contact-us\">contact our leasing team</a> to check current availability and <a href=\"/schedule-a-tour\">schedule your visit</a>.</p>",
  "property_gallery_blurb": "<p>Browse photos of The Residences at Bluhawk in Overland Park, KS, including gourmet kitchens with custom cabinetry, living areas with 9-foot ceilings, private patios and balconies, the pickleball court, the coffee bar, and the landscaped courtyard.</p><p>Ready to see more? <a href=\"/schedule-a-tour\">Schedule a tour</a> of The Residences at Bluhawk.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in South Overland Park.</strong> Use the interactive map to explore available <a href=\"/floor-plans\">apartments</a> at The Residences at Bluhawk, then zoom out to see nearby shopping, dining, recreation, and convenient US-69 access around this connected Bluhawk location.</p>",
  "property_pets_blurb": "<p>The Residences at Bluhawk welcomes cats and dogs, making our Overland Park community a great fit for residents with pets. The Bluhawk neighborhood’s green spaces and nearby parks give pet owners convenient options for daily outings right from the community.</p><p>Up to two pets are permitted per apartment home. Monthly pet rent is $25 per pet, with a $300 non-refundable fee for one pet or $500 total for two pets. Breed restrictions apply. Assistance animals are not considered pets and are not subject to pet fees or restrictions. As a resident of The Residences at Bluhawk, your pets are also members of the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>, which provides special offers and discounts at local pet-related businesses.</p><p><a href=\"/contact-us\">Contact our leasing team</a> at The Residences at Bluhawk for complete pet guidelines, breed restriction details, and current policy information.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at Bluhawk.</strong> Love the spacious floor plans, polished finishes, pet-friendly living, and easy access to shopping, dining, recreation, and Kansas City-area destinations? Invite a friend to experience The Residences at Bluhawk Apartment Homes for themselves.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> Pay rent, submit maintenance requests, and manage your account online—so daily life at The Residences at Bluhawk stays as convenient as the polished finishes, practical comforts, and on-site management that support your home.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback says it best:</strong> life at The Residences at Bluhawk Apartment Homes is shaped by modern apartment finishes, responsive service, and a welcoming atmosphere. Reviewers often point to well-built homes, spacious layouts, natural light, high-quality appliances, and thoughtful storage that make daily living feel easy.</p><p>You’ll also see consistent praise for the team—residents describe management as attentive and maintenance as quick, friendly, and efficient. Add in community events, nearby shopping and dining, parks, and trails, and it’s easy to understand why one resident called Bluhawk a “wonderful place to live.” Browse the reviews below to hear what residents appreciate most.</p>",
  "property_created_at": "1785792797876",
  "property_scheduletour_blurb": "<p>See The Residences at Bluhawk for yourself. Schedule a guided or self-guided tour to explore available apartment homes and community spaces in Overland Park, Kansas.</p><p>During your visit, take a closer look at apartment interiors, <a href=\"/floor-plans\">floor plan options</a>, and community <a href=\"/amenities\">amenities</a> including the pickleball court, gourmet coffee bar, courtyard, and the convenience of the surrounding Bluhawk Entertainment and Shopping Development. Our leasing team will be on hand to answer your questions.</p><p>Choose a tour option and time above to plan your visit to The Residences at Bluhawk.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> Your submission has been received, and the leasing team will follow up soon. In the meantime, picture life at The Residences at Bluhawk Apartment Homes—spacious layouts, polished finishes, everyday conveniences, and a connected South Overland Park setting that keeps dining, shopping, and recreation close.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. The Residences at Bluhawk Apartment Homes",
  "property_seo_title_home": "The Residences at Bluhawk | Overland Park, KS 66085",
  "property_seo_description_home": "Luxury 1, 2 & 3 bedroom apartments in Overland Park, KS. Pickleball court, coffee bar, garages & full-size washer/dryer. Near Bluhawk & AdventHealth.",
  "property_seo_title_floorplans": "1–3 Bedroom Floor Plans | The Residences at Bluhawk",
  "property_seo_description_floorplans": "Browse 1, 2 & 3 bedroom floor plans at The Residences at Bluhawk in Overland Park, KS. 9-ft ceilings, gourmet kitchens, washer/dryer & private patios.",
  "property_seo_title_amenities": "Pickleball, Coffee Bar & Garages | Overland Park KS",
  "property_seo_description_amenities": "The Residences at Bluhawk offers a pickleball court, gourmet coffee bar, garages, guest suite, playground & courtyard in Overland Park, KS. Explore amenities.",
  "property_seo_title_gallery": "Apartment Photos | The Residences at Bluhawk KS",
  "property_seo_description_gallery": "Browse photos of The Residences at Bluhawk in Overland Park, KS — pickleball court, gourmet kitchens, private patios & community spaces. Picture yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | The Residences at Bluhawk Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step into your new home at The Residences at Bluhawk in Overland Park, KS. Take a virtual tour of our stylish one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Residences at Bluhawk Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Residences at Bluhawk in Overland Park, KS. Use our interactive map to explore spacious apartments and vibrant amenities today!",
  "property_seo_title_neighborhood": "Overland Park KS Neighborhood Guide | Bluhawk 66085",
  "property_seo_description_neighborhood": "The Residences at Bluhawk is near Bluhawk Shopping, Downtown Overland Park, Cosentinos, Ironhorse Golf Club & AdventHealth. Easy access to HWY 69 & Kansas City.",
  "property_seo_title_contact": "Contact The Residences at Bluhawk | Overland Park",
  "property_seo_description_contact": "Have questions about our apartments in Overland Park, KS? Reach The Residences at Bluhawk team by phone or online at 16611 Lowell Ave. We'd love to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Find answers to your questions about The Residences at Bluhawk in Overland Park, KS. Learn about our amenities, floor plans, and life in our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Experience life at The Residences at Bluhawk in Overland Park, KS. See what residents love about spacious homes, amenities, and community living!",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover modern living at The Residences at Bluhawk in Overland Park, KS. Enjoy spacious layouts and top amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | The Residences at Bluhawk Apartment Homes",
  "property_seo_description_residentaccess": "Unlock convenience at The Residences at Bluhawk! Access your resident portal for rent payments, maintenance requests, and essential community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Residences at Bluhawk Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to The Residences at Bluhawk in Overland Park! Great neighbors await—share the comfort and community today for a fabulous living experience!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Residences at Bluhawk KS",
  "property_seo_description_scheduletour": "Ready to see The Residences at Bluhawk in person? Schedule an in-person or virtual tour of our 1, 2 & 3 bedroom apartments in Overland Park, KS today!",
  "property_seo_title_privacy": "Privacy Policy | The Residences at Bluhawk Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at The Residences at Bluhawk. Read our policy to understand how we protect your information in Overland Park, KS.",
  "property_seo_title_accessibility": "Website Accessibility | The Residences at Bluhawk Apartment Homes",
  "property_seo_description_accessibility": "Experience seamless living at The Residences at Bluhawk in Overland Park, KS. We prioritize digital inclusion for all residents with our accessible community.",
  "property_seo_title_sitemap": "Sitemap | The Residences at Bluhawk Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way to your next home! Check out the sitemap for The Residences at Bluhawk in Overland Park, KS, and find your perfect fit today!",
  "property_seo_title_thankyou": "Thank You | The Residences at Bluhawk Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out! A team member from The Residences at Bluhawk will connect with you soon to help you find your perfect Overland Park home.",
  "property_seo_title_pets": "Pet-Friendly Apartments | The Residences at Bluhawk",
  "property_seo_description_pets": "The Residences at Bluhawk welcomes cats & dogs in Overland Park, KS. Up to 2 pets per home. Enjoy pet-friendly living & the Price Brothers Pet Royalty Club.",
  "property_updated_at": "1793743008890",
  "amenities": [
    {
      "id": "ec_0f93de5b7688fa8ce119c607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590371",
      "title": "Garages and Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-87db-721c-9c81-3bc1392da0ad.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with asphalt pavement and white markings.",
        "public_id": "01a0b671-87db-721c-9c81-3bc1392da0ad",
        "storage_key": "property/6767906449167619/01a0b671-87db-721c-9c81-3bc1392da0ad.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Parking lot with a long covered parking area at The Residences at Bluhawk Apartments, Overland Park, 66085,Underground Parking Facility at The Residences at Bluhawk Apartments, Overland Park, 66085",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_324191cbf4337ca0d1d96d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590376",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-9da0-72ca-96a1-28a247699108.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slide and swings in a residential community.",
        "public_id": "01a0b671-9da0-72ca-96a1-28a247699108",
        "storage_key": "property/6767906449167619/01a0b671-9da0-72ca-96a1-28a247699108.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Aerial view of playground at The Residences at Bluhawk Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15080c6fed388bf74d702227",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590377",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5a13b9a2d9fb93f55cb8d03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590372",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-88ed-75df-b1ce-642ece1dac86.webp",
      "amenity_image_media": {
        "alt_text": "Bright blue tennis court with net in a multifamily property community.",
        "public_id": "01a0b671-88ed-75df-b1ce-642ece1dac86",
        "storage_key": "property/6767906449167619/01a0b671-88ed-75df-b1ce-642ece1dac86.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Aerial view of Tennis Court at The Residences at Bluhawk Apartments, Overland Park,",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8276b3610639c40e72e33427",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590375",
      "title": "Gourmet Coffee & Hot Tea Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-9d44-77aa-8c81-e21dc5e6a704.webp",
      "amenity_image_media": {
        "alt_text": "Coffee station with a Keurig coffee maker, mini-fridge, and drinks in a hallway.",
        "public_id": "01a0b671-9d44-77aa-8c81-e21dc5e6a704",
        "storage_key": "property/6767906449167619/01a0b671-9d44-77aa-8c81-e21dc5e6a704.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Coffee machine at The Residences at Bluhawk Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac52d4a7d1135e729c011d90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "88190005",
      "title": "Short-Term Rental Guest Suite",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-9d48-727f-863f-feb1e9df6bcc.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with shelf and hanging rack.",
        "public_id": "01a0b671-9d48-727f-863f-feb1e9df6bcc",
        "storage_key": "property/6767906449167619/01a0b671-9d48-727f-863f-feb1e9df6bcc.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A white closet with a wooden floor and a white shelf.,,A bedroom with a bed, nightstand, and television.,A bedroom with a bed, chair, and shelves.,,A kitchen with a table and chairs in the middle of the room.,A laundry room with a washer and dryer.,A kitchen with a granite countertop and a refrigerator.,,,A kitchen with wooden cabinets and stainless steel appliances.,A bedroom with a bed, dresser, and television.,A living room with a grey couch, a grey armchair, a coffee table, and a ceiling fan.,A bathroom with a sink, toilet, and shower.,A bedroom with a bed, chair, and television.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6809c8fa8aeff57eb4a7ee68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590379",
      "title": "Bluhawk Entertainment and Shopping Development",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-ad34-77c0-82ef-6e49822c3813.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a large mixed-use development with apartment buildings, retail spaces, and parking lots surrounding a central courtyard area.",
        "public_id": "01a0b671-ad34-77c0-82ef-6e49822c3813",
        "storage_key": "property/6767906449167619/01a0b671-ad34-77c0-82ef-6e49822c3813.webp",
        "width": 859,
        "height": 432
      },
      "amenity_image_alt_text": "Aerial View at The Residences at Bluhawk Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78a98a3233e49404337fd764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590378",
      "title": "Award Winning Blue Valley School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_857d7c56adb9b1ec07abd056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "112507857",
      "title": "Hawk Flock Membership Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea3066a390ed1f14bca8c19e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "122755414",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4817d3ab9764b1d2db5f94fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590373",
      "title": "Online Rent Payment & Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7943234e1a1220ea1aa38e40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590370",
      "title": "Wired for Today's Technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c594d31faffa1b6bdc80f79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590374",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6175c1a2c259bb76f4ec544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590380",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-941f-77cc-ba36-e15fd95e7df2.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving",
        "public_id": "01a0b671-941f-77cc-ba36-e15fd95e7df2",
        "storage_key": "property/6767906449167619/01a0b671-941f-77cc-ba36-e15fd95e7df2.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Empty white shelves at The Residences at Bluhawk Apartments, Overland Park, 66085",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15b477e926ca9f4cdd1ec98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590387",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-9f2b-774d-913d-88500bb08c65.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating area and table overlooking a field",
        "public_id": "01a0b671-9f2b-774d-913d-88500bb08c65",
        "storage_key": "property/6767906449167619/01a0b671-9f2b-774d-913d-88500bb08c65.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "Large Private Patios & Balconies at The Residences at Bluhawk Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3720b8215e2e66679088267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590388",
      "title": "Lofty Nine Foot Ceilings",
      "amount": "false",
      "description": "with crown molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f38a01047ba1174957f998bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590389",
      "title": "Power Saving Digital Programmable Thermostats",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df9c7dba13b3fe7a1b570594",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590391",
      "title": "Ceiling Fans w/Lighting in Bedrooms & Living Rooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-a72c-7066-a1d8-a5ffdfb15ee6.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen of an apartment with a white couch, dining table, and modern kitchen.",
        "public_id": "01a0b671-a72c-7066-a1d8-a5ffdfb15ee6",
        "storage_key": "property/6767906449167619/01a0b671-a72c-7066-a1d8-a5ffdfb15ee6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Living room and Dining room at The Residences at Bluhawk Apartments, Kansas, 66085,Bedroom with large bed and a ceiling fan at The Residences at Bluhawk Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b398f379cdd62b9413cce4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590392",
      "title": "Full Size Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-aa09-70bd-bb34-4ecc7d093505.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer in a laundry room with a shelf and a closed door.",
        "public_id": "01a0b671-aa09-70bd-bb34-4ecc7d093505",
        "storage_key": "property/6767906449167619/01a0b671-aa09-70bd-bb34-4ecc7d093505.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "White washing machine and dryer at The Residences at Bluhawk Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1586436df37b86b2eac34c9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590381",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-aa68-71fc-9f1c-a0350e74d08a.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinets",
        "public_id": "01a0b671-aa68-71fc-9f1c-a0350e74d08a",
        "storage_key": "property/6767906449167619/01a0b671-aa68-71fc-9f1c-a0350e74d08a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Kitchen with Stainless steel refrigerator and cabinets at The Residences at Bluhawk Apartments, Overland Park, 66085",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53b54819e0acfb3bcf9a83f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590382",
      "title": "Gourmet Kitchens",
      "amount": "false",
      "description": "with Designer Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-5e8b-70b3-9264-c652403c6385.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances",
        "public_id": "01a0b671-5e8b-70b3-9264-c652403c6385",
        "storage_key": "property/6767906449167619/01a0b671-5e8b-70b3-9264-c652403c6385.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Kitchen with wooden cabinets at The Residences at Bluhawk Apartments, Kansas, 66085",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80ba8defe8af3d450ff89418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590383",
      "title": "Custom Wood Cabinetry",
      "amount": "false",
      "description": "with Brushed Nickel Hardware",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-c47e-7298-8bdd-e03296bd256d.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, large mirror, and walk-in closet.",
        "public_id": "01a0b671-c47e-7298-8bdd-e03296bd256d",
        "storage_key": "property/6767906449167619/01a0b671-c47e-7298-8bdd-e03296bd256d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bright bathroom with a large mirror at The Residences at Bluhawk Apartments, Overland Park, KS,Bathroom with glass separated shower at The Residences at Bluhawk Apartments, Overland Park, KS, 66085",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38a2fdc7b36259e2d8d01a47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590384",
      "title": "Two Tone Paint Color Scheme",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_815ca05077bac7e43bd15606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590385",
      "title": "Stylish Track & Pendant Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-c466-711f-8f41-e007339d1f25.webp",
      "amenity_image_media": {
        "alt_text": "Open-concept living area and kitchen with a breakfast bar, stainless steel appliances, and a balcony view.",
        "public_id": "01a0b671-c466-711f-8f41-e007339d1f25",
        "storage_key": "property/6767906449167619/01a0b671-c466-711f-8f41-e007339d1f25.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Spacious and well lit kitchen at The Residences at Bluhawk Apartments, Overland Park,",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72d1968f091cdcdc351b9575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590386",
      "title": "Custom Tile Showers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-cc52-778c-b562-5cb404517d21.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
        "public_id": "01a0b671-cc52-778c-b562-5cb404517d21",
        "storage_key": "property/6767906449167619/01a0b671-cc52-778c-b562-5cb404517d21.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bathroom with glass separated shower at The Residences at Bluhawk Apartments, Overland Park, KS, 66085",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_885f46cc80bca544f0c0b848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "87590390",
      "title": "2-inch Faux Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f88fddd1b4994a52941eb7ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "external_id": "122011640",
      "title": "Handicap",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_030b874afdf0e577511e0de9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-5e8b-70b3-9264-c652403c6385.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances",
        "public_id": "01a0b671-5e8b-70b3-9264-c652403c6385",
        "storage_key": "property/6767906449167619/01a0b671-5e8b-70b3-9264-c652403c6385.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, a large island with bar seating, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/33-16611 Lowell Ave-2 copy_final(1).jpg"
    },
    {
      "id": "ec_5c99f070346983b7d2e66497",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-a72c-7066-a1d8-a5ffdfb15ee6.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of an apartment with a white couch, dining table, and modern kitchen.",
        "public_id": "01a0b671-a72c-7066-a1d8-a5ffdfb15ee6",
        "storage_key": "property/6767906449167619/01a0b671-a72c-7066-a1d8-a5ffdfb15ee6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen featuring a comfortable white sofa, elegant dining area, and a fully equipped modern kitchen with stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen of an apartment with a white couch, dining table, and modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/34-16611 Lowell Ave-3 copy_final(1).jpg"
    },
    {
      "id": "ec_9f0fb26e0afd0cdc9f4aa652",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-c466-711f-8f41-e007339d1f25.webp",
      "image_media": {
        "alt_text": "Open-concept living area and kitchen with a breakfast bar, stainless steel appliances, and a balcony view.",
        "public_id": "01a0b671-c466-711f-8f41-e007339d1f25",
        "storage_key": "property/6767906449167619/01a0b671-c466-711f-8f41-e007339d1f25.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area seamlessly integrated with a modern kitchen, featuring a breakfast bar and stainless steel appliances. Step out onto the balcony and enjoy the scenic views.",
      "link": "false",
      "alt_text": "Open-concept living area and kitchen with a breakfast bar, stainless steel appliances, and a balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/35-16611 Lowell Ave-4 copy_final(1).jpg"
    },
    {
      "id": "ec_93e932adcf3100ca99f0928b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-aa68-71fc-9f1c-a0350e74d08a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinets",
        "public_id": "01a0b671-aa68-71fc-9f1c-a0350e74d08a",
        "storage_key": "property/6767906449167619/01a0b671-aa68-71fc-9f1c-a0350e74d08a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring sleek stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and wood cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-16611 Lowell Ave-1 copy_final(1).jpg"
    },
    {
      "id": "ec_6b6f8ba429eb43254620757d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-c47e-7298-8bdd-e03296bd256d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, large mirror, and walk-in closet.",
        "public_id": "01a0b671-c47e-7298-8bdd-e03296bd256d",
        "storage_key": "property/6767906449167619/01a0b671-c47e-7298-8bdd-e03296bd256d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into luxury with this stunning bathroom featuring a spacious double vanity with granite countertops, a large mirror reflecting the elegant design, and a convenient walk-in closet.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, granite countertops, large mirror, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/38-16611 Lowell Ave-8 copy_final.jpg"
    },
    {
      "id": "ec_acd2b7116239535de591a3b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-cc52-778c-b562-5cb404517d21.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
        "public_id": "01a0b671-cc52-778c-b562-5cb404517d21",
        "storage_key": "property/6767906449167619/01a0b671-cc52-778c-b562-5cb404517d21.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek walk-in shower with marble accents, a granite-top vanity with dark wood cabinetry, and a toilet.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/36-16611 Lowell Ave-6 copy_final.jpg"
    },
    {
      "id": "ec_d096a4afac45cc3a8c01f508",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-d79f-73b4-b459-9aa344e8ad98.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, ceiling fan, and an open door to the bathroom.",
        "public_id": "01a0b671-d79f-73b4-b459-9aa344e8ad98",
        "storage_key": "property/6767906449167619/01a0b671-d79f-73b4-b459-9aa344e8ad98.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a ceiling fan, and a stylish chair. An adjoining bathroom and a glimpse of the kitchen are visible.",
      "link": "false",
      "alt_text": "Bedroom with a bed, ceiling fan, and an open door to the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/37-16611 Lowell Ave-7 copy_final(1).jpg"
    },
    {
      "id": "ec_697f95e0e8abc86500ef6a81",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-941f-77cc-ba36-e15fd95e7df2.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving",
        "public_id": "01a0b671-941f-77cc-ba36-e15fd95e7df2",
        "storage_key": "property/6767906449167619/01a0b671-941f-77cc-ba36-e15fd95e7df2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample white wire shelving for all your storage needs.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-16611 Lowell Ave-9(2).jpg"
    },
    {
      "id": "ec_bba8bc1e3bf349793354478c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-aa09-70bd-bb34-4ecc7d093505.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room with a shelf and a closed door.",
        "public_id": "01a0b671-aa09-70bd-bb34-4ecc7d093505",
        "storage_key": "property/6767906449167619/01a0b671-aa09-70bd-bb34-4ecc7d093505.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry days. This apartment features a dedicated laundry space with a shelving unit for storage and a door for privacy.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry room with a shelf and a closed door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-16611 Lowell Ave-5.jpg"
    },
    {
      "id": "ec_74e52019e68b3fb231fbeff0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-db8e-7122-bb4f-235465cc5448.webp",
      "image_media": {
        "alt_text": "Balcony with a small table set for two and a view of greenery and sky.",
        "public_id": "01a0b671-db8e-7122-bb4f-235465cc5448",
        "storage_key": "property/6767906449167619/01a0b671-db8e-7122-bb4f-235465cc5448.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private balcony, offering serene views.",
      "link": "false",
      "alt_text": "Balcony with a small table set for two and a view of greenery and sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/39-16611 Lowell Ave-10 copy_final.jpg"
    },
    {
      "id": "ec_14183c12c1c55c6aa3d19558",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-db24-76da-b7f9-422392737821.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with a parking lot and dramatic sunset sky.",
        "public_id": "01a0b671-db24-76da-b7f9-422392737821",
        "storage_key": "property/6767906449167619/01a0b671-db24-76da-b7f9-422392737821.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Discover modern apartment living with this stunning exterior view, showcasing the building's architecture against a vibrant sunset. Enjoy ample parking and beautifully landscaped grounds.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily apartment building with a parking lot and dramatic sunset sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/41-Lowell Twilight-2.jpg"
    },
    {
      "id": "ec_4494e0b8973fc11744dac928",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-e0f7-7043-adb2-5bec8227d65d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings at sunset with a winding road in the foreground.",
        "public_id": "01a0b671-e0f7-7043-adb2-5bec8227d65d",
        "storage_key": "property/6767906449167619/01a0b671-e0f7-7043-adb2-5bec8227d65d.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Experience elevated living in these stunning apartment buildings, showcased against a breathtaking sunset and surrounded by lush greenery.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings at sunset with a winding road in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/40-Lowell Twilight-1(1).jpg"
    },
    {
      "id": "ec_c983660d8bb3777926747c11",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-fb41-735a-b8ab-da7353fd5d5e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and green landscaping.",
        "public_id": "01a0b671-fb41-735a-b8ab-da7353fd5d5e",
        "storage_key": "property/6767906449167619/01a0b671-fb41-735a-b8ab-da7353fd5d5e.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "An exterior view of apartment buildings showcasing the property's architecture, parking amenities, and surrounding green spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with parking lot and green landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-16611 Lowell Ave-18(1).jpg"
    },
    {
      "id": "ec_5d7d071fd900bad6550ed38f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-fb26-70c3-9eb6-4d0529a161d9.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with stone and pink siding, balconies, and lush green landscaping.",
        "public_id": "01a0b671-fb26-70c3-9eb6-4d0529a161d9",
        "storage_key": "property/6767906449167619/01a0b671-fb26-70c3-9eb6-4d0529a161d9.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Spacious apartment building exterior featuring a mix of stone and pink siding, private balconies, and beautifully maintained grounds. A welcoming entrance to modern living.",
      "link": "false",
      "alt_text": "Exterior of a multi-story apartment building with stone and pink siding, balconies, and lush green landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-16611 Lowell Ave-13.jpg"
    },
    {
      "id": "ec_8c4d2fc3831d62fbdf3acb67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-ec2b-77be-8a49-d94011aa6721.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding suburban neighborhood.",
        "public_id": "01a0b671-ec2b-77be-8a49-d94011aa6721",
        "storage_key": "property/6767906449167619/01a0b671-ec2b-77be-8a49-d94011aa6721.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Discover modern apartment living surrounded by a vibrant community and convenient access to major roadways. Enjoy the best of suburban life.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and surrounding suburban neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-16611 Lowell Ave-17.jpg"
    },
    {
      "id": "ec_32f76ef1054182e3db77460d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-0351-7754-b7ab-d1b4bfa465b0.webp",
      "image_media": {
        "alt_text": "Aerial view of the large sports complex with expansive grounds and surrounding landscape.",
        "public_id": "01a0b672-0351-7754-b7ab-d1b4bfa465b0",
        "storage_key": "property/6767906449167619/01a0b672-0351-7754-b7ab-d1b4bfa465b0.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Discover the expansive sports complex, featuring state-of-the-art facilities and ample green space for recreation and events. An ideal destination for athletes and families alike.",
      "link": "false",
      "alt_text": "Aerial view of the large sports complex with expansive grounds and surrounding landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-16611 Lowell Ave-19.jpg"
    },
    {
      "id": "ec_6f18bb075ae2a041ea0c271c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-03a2-755a-9fa7-18895cbd4d7a.webp",
      "image_media": {
        "alt_text": "Aerial view of a large sports park facility with a parking lot and surrounding landscape.",
        "public_id": "01a0b672-03a2-755a-9fa7-18895cbd4d7a",
        "storage_key": "property/6767906449167619/01a0b672-03a2-755a-9fa7-18895cbd4d7a.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Explore the expansive grounds of our sports park, featuring state-of-the-art facilities and ample parking, set against a backdrop of scenic green spaces.",
      "link": "false",
      "alt_text": "Aerial view of a large sports park facility with a parking lot and surrounding landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-16611 Lowell Ave-20.jpg"
    },
    {
      "id": "ec_733691c2e29c28a6f4ef6694",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-fceb-701a-9577-fef322c5a184.webp",
      "image_media": {
        "alt_text": "Signage for The Residences at BluHawk with apartment buildings in the background.",
        "public_id": "01a0b671-fceb-701a-9577-fef322c5a184",
        "storage_key": "property/6767906449167619/01a0b671-fceb-701a-9577-fef322c5a184.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Welcome to The Residences at BluHawk, a vibrant community offering modern apartments and amenities. Explore our beautiful grounds and discover your new home.",
      "link": "false",
      "alt_text": "Signage for The Residences at BluHawk with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/4BH-Amenities-2.jpg"
    },
    {
      "id": "ec_cb1b9d9a98f160e1f302a5e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-88ed-75df-b1ce-642ece1dac86.webp",
      "image_media": {
        "alt_text": "Bright blue tennis court with net in a multifamily property community.",
        "public_id": "01a0b671-88ed-75df-b1ce-642ece1dac86",
        "storage_key": "property/6767906449167619/01a0b671-88ed-75df-b1ce-642ece1dac86.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle at our community with a vibrant blue tennis court perfect for a friendly match.",
      "link": "false",
      "alt_text": "Bright blue tennis court with net in a multifamily property community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-16611 Lowell Ave-15.jpg"
    },
    {
      "id": "ec_dfc8f7bff6bb5540fb0d124c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-9da0-72ca-96a1-28a247699108.webp",
      "image_media": {
        "alt_text": "Playground with slide and swings in a residential community.",
        "public_id": "01a0b671-9da0-72ca-96a1-28a247699108",
        "storage_key": "property/6767906449167619/01a0b671-9da0-72ca-96a1-28a247699108.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring a slide and swings, perfect for families.",
      "link": "false",
      "alt_text": "Playground with slide and swings in a residential community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-16611 Lowell Ave-12.jpg"
    },
    {
      "id": "ec_15ec40d0482566a6a1ec8276",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-0b53-752e-8e7f-30beb6a1c73c.webp",
      "image_media": {
        "alt_text": "Mailboxes located under stone arches.",
        "public_id": "01a0b672-0b53-752e-8e7f-30beb6a1c73c",
        "storage_key": "property/6767906449167619/01a0b672-0b53-752e-8e7f-30beb6a1c73c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Secure mailboxes are conveniently located under decorative stone arches.",
      "link": "false",
      "alt_text": "Mailboxes located under stone arches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-16611 Lowell Ave-11.jpg"
    },
    {
      "id": "ec_f3b399863f8a392fa5604099",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b671-87db-721c-9c81-3bc1392da0ad.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with asphalt pavement and white markings.",
        "public_id": "01a0b671-87db-721c-9c81-3bc1392da0ad",
        "storage_key": "property/6767906449167619/01a0b671-87db-721c-9c81-3bc1392da0ad.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Covered parking spaces available for residents, providing protection from the elements and convenient parking options.",
      "link": "false",
      "alt_text": "Covered parking spaces with asphalt pavement and white markings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-16611 Lowell Ave-21.jpg"
    },
    {
      "id": "ec_d2bf7d9270daea004ce35e18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-12dd-759d-a9b7-8b7b0d2253ea.webp",
      "image_media": {
        "alt_text": "Empty garage with an open door showing a parking lot and building.",
        "public_id": "01a0b672-12dd-759d-a9b7-8b7b0d2253ea",
        "storage_key": "property/6767906449167619/01a0b672-12dd-759d-a9b7-8b7b0d2253ea.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Rent a private garage to protect your vehicle from the elements and keep your belongings organized.",
      "link": "false",
      "alt_text": "Empty garage with an open door showing a parking lot and building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/4BH-Amenities-11.jpg"
    },
    {
      "id": "ec_c47717f14f22315951cee11e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-1198-710f-bf37-a9efaa9b72cf.webp",
      "image_media": {
        "alt_text": "Interior of a spacious garage with three open garage doors, revealing the exterior of apartment buildings.",
        "public_id": "01a0b672-1198-710f-bf37-a9efaa9b72cf",
        "storage_key": "property/6767906449167619/01a0b672-1198-710f-bf37-a9efaa9b72cf.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Spacious garage interior with multiple open garage doors, offering convenient parking and storage with views of the apartment community's exterior.",
      "link": "false",
      "alt_text": "Interior of a spacious garage with three open garage doors, revealing the exterior of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/4BH-Amenities-9.jpg"
    },
    {
      "id": "ec_5e5adf90976e4218bd3d6a61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-3019-723a-88df-91678fa16b73.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "01a0b672-3019-723a-88df-91678fa16b73",
        "storage_key": "property/6767906449167619/01a0b672-3019-723a-88df-91678fa16b73.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-16611 Lowell Ave ste 2202 -5(1).jpg"
    },
    {
      "id": "ec_9f64fb5dbb1fa17be84041fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-1f02-751c-89c6-d226afcd7825.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstand, and dresser with TV.",
        "public_id": "01a0b672-1f02-751c-89c6-d226afcd7825",
        "storage_key": "property/6767906449167619/01a0b672-1f02-751c-89c6-d226afcd7825.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed, plush carpeting, and a ceiling fan. Includes a nightstand with a lamp and a dresser with a TV.",
      "link": "false",
      "alt_text": "Bedroom with queen bed, nightstand, and dresser with TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-16611 Lowell Ave ste 2202 -6(1).jpg"
    },
    {
      "id": "ec_6f0324978798337ae1c2fd68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-34d3-777f-ac32-0f7938f5f372.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and a dining area.",
        "public_id": "01a0b672-34d3-777f-ac32-0f7938f5f372",
        "storage_key": "property/6767906449167619/01a0b672-34d3-777f-ac32-0f7938f5f372.webp",
        "width": 3000,
        "height": 1999
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this spacious kitchen featuring granite countertops, stainless steel appliances, and a charming breakfast nook.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-16611 Lowell Ave ste 2202 -3(1).jpg"
    },
    {
      "id": "ec_ab71e4e1c2c1a140991d1dd2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-1f73-7653-b687-de9f52a7e2b3.webp",
      "image_media": {
        "alt_text": "Empty closet with shelf and hanging clothes.",
        "public_id": "01a0b672-1f73-7653-b687-de9f52a7e2b3",
        "storage_key": "property/6767906449167619/01a0b672-1f73-7653-b687-de9f52a7e2b3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and hanging space, ready to store your belongings.",
      "link": "false",
      "alt_text": "Empty closet with shelf and hanging clothes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-16611 Lowell Ave ste 2202 -15(1).jpg"
    },
    {
      "id": "ec_caceb6cba5c3931b8a76bcd2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-259f-765d-a6a4-663e10f9f11a.webp",
      "image_media": {
        "alt_text": "Open concept dining area and kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "01a0b672-259f-765d-a6a4-663e10f9f11a",
        "storage_key": "property/6767906449167619/01a0b672-259f-765d-a6a4-663e10f9f11a.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy spacious, open-concept living with a modern kitchen featuring granite countertops, stainless steel appliances, and a convenient breakfast bar.",
      "link": "false",
      "alt_text": "Open concept dining area and kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-16611 Lowell Ave ste 2202 -4(1).jpg"
    },
    {
      "id": "ec_ef0f1d87af2915c8fbd5d236",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-3e8a-750e-8285-6ec936041f89.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, nightstand, chair, and dresser with a TV.",
        "public_id": "01a0b672-3e8a-750e-8285-6ec936041f89",
        "storage_key": "property/6767906449167619/01a0b672-3e8a-750e-8285-6ec936041f89.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bedroom. Featuring a comfortable queen-size bed, elegant furnishings, and ample space for your belongings.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed, nightstand, chair, and dresser with a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-16611 Lowell Ave ste 2202 -8(1).jpg"
    },
    {
      "id": "ec_c274abba7d7b4ea233bf2471",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-39d8-756f-bd2d-5b952c50ea0c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, dresser, ceiling fan, and access to a bathroom.",
        "public_id": "01a0b672-39d8-756f-bd2d-5b952c50ea0c",
        "storage_key": "property/6767906449167619/01a0b672-39d8-756f-bd2d-5b952c50ea0c.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom featuring a plush king-size bed, elegant nightstand, and convenient access to a well-appointed bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstand, dresser, ceiling fan, and access to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-16611 Lowell Ave ste 2202 -9(1).jpg"
    },
    {
      "id": "ec_0ccd8ce82acd500dc4c8fbec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-428e-7018-8021-f00eb72d41ec.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, granite countertops, and a glass-enclosed shower.",
        "public_id": "01a0b672-428e-7018-8021-f00eb72d41ec",
        "storage_key": "property/6767906449167619/01a0b672-428e-7018-8021-f00eb72d41ec.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a large vanity with granite countertops, a walk-in glass shower, and contemporary fixtures for a luxurious feel.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, granite countertops, and a glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-16611 Lowell Ave ste 2202 -11(1).jpg"
    },
    {
      "id": "ec_ad0e0fa9e5544a0102219a1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-4b8b-76c2-be5b-9ff3cb4150f3.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertops, walk-in closet, and glass shower.",
        "public_id": "01a0b672-4b8b-76c2-be5b-9ff3cb4150f3",
        "storage_key": "property/6767906449167619/01a0b672-4b8b-76c2-be5b-9ff3cb4150f3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a large mirror with vanity lighting, a walk-in closet, and a sleek glass-enclosed shower.",
      "link": "false",
      "alt_text": "Double vanity with granite countertops, walk-in closet, and glass shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-16611 Lowell Ave ste 2202 -14(1).jpg"
    },
    {
      "id": "ec_210920552cefc46163760df7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-515f-726a-8560-843154589de1.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with seating, dining table, and stainless steel appliances.",
        "public_id": "01a0b672-515f-726a-8560-843154589de1",
        "storage_key": "property/6767906449167619/01a0b672-515f-726a-8560-843154589de1.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Step into this beautifully furnished apartment, featuring an open-concept living and dining area with a modern kitchen. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room and kitchen area with seating, dining table, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-16611 Lowell Ave ste 2202 -2(1).jpg"
    },
    {
      "id": "ec_34c6799dd419d75769879fff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-55f7-7798-9666-01a718bbc293.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving",
        "public_id": "01a0b672-55f7-7798-9666-01a718bbc293",
        "storage_key": "property/6767906449167619/01a0b672-55f7-7798-9666-01a718bbc293.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving, perfect for organizing your belongings. This feature adds convenience and maximizes storage space in your apartment.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-16611 Lowell Ave ste 2202 -10(1).jpg"
    },
    {
      "id": "ec_e628bd2e7f6bc880eb5b006c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-7493-7540-b789-cffae40e35ba.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, ceiling fan, TV, and ample closet space.",
        "public_id": "01a0b672-7493-7540-b789-cffae40e35ba",
        "storage_key": "property/6767906449167619/01a0b672-7493-7540-b789-cffae40e35ba.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush queen-size bed, a modern ceiling fan, a wall-mounted TV, and a spacious double-door closet.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, ceiling fan, TV, and ample closet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-16611 Lowell Ave ste 2202 -7(1).jpg"
    },
    {
      "id": "ec_7aa152613010475acd87fc82",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-60f9-7176-9534-c4d0e97e8eac.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet with a shelf above.",
        "public_id": "01a0b672-60f9-7176-9534-c4d0e97e8eac",
        "storage_key": "property/6767906449167619/01a0b672-60f9-7176-9534-c4d0e97e8eac.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, located in a dedicated laundry closet with overhead storage.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry closet with a shelf above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-16611 Lowell Ave ste 2202 -12(1).jpg"
    },
    {
      "id": "ec_c5beca52d4421eb3b1d78ce1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-672d-755e-84d5-9fbae1748670.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, chair, and doorway to bathroom",
        "public_id": "01a0b672-672d-755e-84d5-9fbae1748670",
        "storage_key": "property/6767906449167619/01a0b672-672d-755e-84d5-9fbae1748670.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a stylish accent chair, and a convenient en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a bed, chair, and doorway to bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-16611 Lowell Ave ste 2202 -13(1).jpg"
    },
    {
      "id": "ec_61e090aa0a301122e348c5b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-6d4f-7121-91a5-329ac58acff4.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and mounted TV.",
        "public_id": "01a0b672-6d4f-7121-91a5-329ac58acff4",
        "storage_key": "property/6767906449167619/01a0b672-6d4f-7121-91a5-329ac58acff4.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A stylish and comfortable living room featuring a plush gray sofa, elegant armchair, and a modern coffee table, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with gray sofa, armchair, coffee table, and mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-16611 Lowell Ave ste 2202 -1(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_37d6adc8-123a-4774-b466-522d154be9f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Of Course Kitchen & Company",
      "poi_type": "Restaurants",
      "poi_address": "7753 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-0e92-71cd-b2b0-aa14902439eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-0e92-71cd-b2b0-aa14902439eb",
        "storage_key": "property/6767906449167619/019fc993-0e92-71cd-b2b0-aa14902439eb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ofcoursekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8729084053667098514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "of-course-kitchen--company",
      "poi_latitude": "38.8389303",
      "poi_longitude": "-94.67779",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-261-9187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-bOnXTBwIcRkq9aubLvI3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8fd851c4-404e-49bf-aaef-d31c40eb9533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Red Door Woodfired Grill",
      "poi_type": "Restaurants",
      "poi_address": "8001 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Burgers, steaks & other American classics offered in airy, industrial surrounds with patio seating.",
      "poi_long_description": "Burgers, steaks & other American classics offered in airy, industrial surrounds with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc992-e911-723a-a56b-859180548f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-e911-723a-a56b-859180548f0f",
        "storage_key": "property/6767906449167619/019fc992-e911-723a-a56b-859180548f0f.webp",
        "width": 1000,
        "height": 751
      },
      "poi_business_url": "https://reddoorgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7981812448351942793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-door-woodfired-grill",
      "poi_latitude": "38.8395569",
      "poi_longitude": "-94.6837733",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-276-3667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8S1DBvBwIcRifjO3yEYxW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9cae3c45-7b6c-4322-b2fb-dc8b866733cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Gyu-Kaku Japanese BBQ",
      "poi_type": "Restaurants",
      "poi_address": "7865 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Trendy eatery offering cuts of beef and other meats to grill yourself, plus sake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0100b-06be-76e5-8d7a-60b811291d91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100b-06be-76e5-8d7a-60b811291d91",
        "storage_key": "property/6767906449167619/01a0100b-06be-76e5-8d7a-60b811291d91.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gyu-kaku.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=10318845706689440892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gyu-kaku-japanese-bbq",
      "poi_latitude": "38.8393448",
      "poi_longitude": "-94.6816093",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-681-9788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__7iCgDBwIcRfOxJp3_nM48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_ef1678b2-90db-41ed-bf78-5503d2753da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "JINYA Ramen Bar - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7761 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Japanese restaurant spotlighting made-to-order ramen served in contemporary surrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-1026-738d-bbac-1297d82fd689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-1026-738d-bbac-1297d82fd689",
        "storage_key": "property/6767906449167619/019fc993-1026-738d-bbac-1297d82fd689.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.jinyaramenbar.com/locations/overland-park/?utm_medium=soci&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6062536225584573567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jinya-ramen-bar---overland-park",
      "poi_latitude": "38.8393163",
      "poi_longitude": "-94.6780583",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-261-9598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaO6_yfBwIcRf-znk5N0IlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_10d789ba-6df9-4c1f-8b9c-7ae18e17a5f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Magic Noodle",
      "poi_type": "Restaurants",
      "poi_address": "8013 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Beef-centric spot serving made-in-house noodles in soups and stir-fries, plus dumplings and fried rice.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-2f51-7310-a424-1dee2e4a0c60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-2f51-7310-a424-1dee2e4a0c60",
        "storage_key": "property/6767906449167619/019fc993-2f51-7310-a424-1dee2e4a0c60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.toasttab.com/online/magic-noodle-overland-park-em-8013-west-159th-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=15668768872229083431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magic-noodle",
      "poi_latitude": "38.8395663",
      "poi_longitude": "-94.6840271",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-261-9783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJswW7L1fBwIcRJ5npyEWmctk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_noodle_restaurant"
    },
    {
      "id": "custom_c8b44ea3-65cc-422f-a583-d18aec2656f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "7871 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-31a4-738b-8af7-64f5181fb899.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-31a4-738b-8af7-64f5181fb899",
        "storage_key": "property/6767906449167619/019fc993-31a4-738b-8af7-64f5181fb899.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ks/overland-park/7871-west-159th-st?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202400&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=17493627990922944945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "38.8391532",
      "poi_longitude": "-94.682353",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-336-1755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-4138-7673-b457-31f6830d4125.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4138-7673-b457-31f6830d4125",
        "storage_key": "property/6767906449167619/019ff6a4-4138-7673-b457-31f6830d4125.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB7rEbvLBwIcRseHK9_jZxfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_bab020fe-3597-48f5-b006-72b6cb3117e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "7733 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-38be-7315-b60f-6919e3579357.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-38be-7315-b60f-6919e3579357",
        "storage_key": "property/6767906449167619/019fc993-38be-7315-b60f-6919e3579357.webp",
        "width": 1280,
        "height": 941
      },
      "poi_business_url": "https://restaurants.fiveguys.com/7733-west-159th-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=12631802473904714387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "38.8386655",
      "poi_longitude": "-94.6778437",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-730-8101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6YDoZXBwIcRk7L9gWwtTa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_bc9bce25-9063-48ac-add1-909cba263baa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Freddy's Frozen Custard & Steakburgers",
      "poi_type": "Restaurants",
      "poi_address": "7831 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_long_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-2e1b-71da-91b1-79e5d0f77963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-2e1b-71da-91b1-79e5d0f77963",
        "storage_key": "property/6767906449167619/019fc993-2e1b-71da-91b1-79e5d0f77963.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.freddys.com/location/bluhawk-overland-park-ks?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5328253813685054166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freddys-frozen-custard--steakburgers",
      "poi_latitude": "38.8392512",
      "poi_longitude": "-94.6805782",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-348-4948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WRK4R3BwIcR1mrR_ZzC8Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_669cb11b-3333-4932-ad88-5c8b6e30a344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "7791 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-1ac6-77ae-ad6f-49712917d102.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-1ac6-77ae-ad6f-49712917d102",
        "storage_key": "property/6767906449167619/019ff6a3-1ac6-77ae-ad6f-49712917d102.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "https://locations.whataburger.com/ks/overland-park/7791-west-159th-street.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=6243154949632544444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "38.8391719",
      "poi_longitude": "-94.6791017",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-701-3551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbYrmZXBwIcRvM6RWlkkpFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9b019be2-767b-4b34-bbc6-035c5412cde3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Cactus Grill",
      "poi_type": "Restaurants",
      "poi_address": "7841 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Casual Mexican restaurant offering beer, wine, cocktails and classic dishes alongside Tex-Mex fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-0dc9-70b9-b50d-8356176ad4ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-0dc9-70b9-b50d-8356176ad4ae",
        "storage_key": "property/6767906449167619/019fc993-0dc9-70b9-b50d-8356176ad4ae.webp",
        "width": 1280,
        "height": 915
      },
      "poi_business_url": "https://www.cactusgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10366034956803318077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cactus-grill",
      "poi_latitude": "38.8393023",
      "poi_longitude": "-94.6811571",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-354-2272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXEnIWnBwIcRPSGLId-N248",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_89306f30-3413-4386-b274-8404ad8f2701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Andy's Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "7781 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_long_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc992-f455-74bd-bb93-7c3b0eb94c00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-f455-74bd-bb93-7c3b0eb94c00",
        "storage_key": "property/6767906449167619/019fc992-f455-74bd-bb93-7c3b0eb94c00.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatandys.com/ll/US/KS/Overland-Park/7781-West-159th-Street",
      "poi_directions_map_url": "https://maps.google.com/?cid=13552781404911816966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andys-frozen-custard",
      "poi_latitude": "38.8396953",
      "poi_longitude": "-94.6783006",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-735-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKZsjFHjBwIcRBtFJzuEmFbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_94cf2ec4-50f4-4220-975a-629516d632bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Jersey Mike's Subs",
      "poi_type": "Restaurants",
      "poi_address": "15901 Antioch Rd, Overland Park, KS 66223, USA",
      "poi_short_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_long_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-7d9b-752b-a0b4-f217f7ff8708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-7d9b-752b-a0b4-f217f7ff8708",
        "storage_key": "property/6767906449167619/01a0b66d-7d9b-752b-a0b4-f217f7ff8708.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jerseymikes.com/21006/overland-park-ks?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5999408615580071491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-mikes-subs",
      "poi_latitude": "38.83935640000001",
      "poi_longitude": "-94.685419",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-730-8862",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSwDmR3BwIcRQ3YRglkuQlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_c3070014-1ca9-4cf7-9b0b-28414fb73442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Nekter Juice Bar",
      "poi_type": "Restaurants",
      "poi_address": "7769 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Local juice-bar chain offering specialty drinks, cleanses & health-conscious snacks.",
      "poi_long_description": "Local juice-bar chain offering specialty drinks, cleanses & health-conscious snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-1aff-716b-a946-9d17a3c95536.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-1aff-716b-a946-9d17a3c95536",
        "storage_key": "property/6767906449167619/019fc993-1aff-716b-a946-9d17a3c95536.webp",
        "width": 1280,
        "height": 432
      },
      "poi_business_url": "https://locations.nekterjuicebar.com/ll/us/ks/overland-park/7769-w-159th-street/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12043542290178796383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nekter-juice-bar",
      "poi_latitude": "38.8393319",
      "poi_longitude": "-94.6782198",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-291-0117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeWwr7O3BwIcRX2uAS-dBI6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_26caee6f-d937-4be5-8d70-42e9bdaa43f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Costa Vida Fresh Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8093 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Laid-back counter-serve Mexican chain with Baja-style tacos & burritos, plus gluten-free options.",
      "poi_long_description": "Laid-back counter-serve Mexican chain with Baja-style tacos & burritos, plus gluten-free options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0100b-12b8-717f-8e4b-7f4c7129e0c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100b-12b8-717f-8e4b-7f4c7129e0c4",
        "storage_key": "property/6767906449167619/01a0100b-12b8-717f-8e4b-7f4c7129e0c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costavida.com/locations/us/ks/overland-park/8093-w-159th/?utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13019987956346445824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costa-vida-fresh-mexican-grill",
      "poi_latitude": "38.8395699",
      "poi_longitude": "-94.6848825",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-685-8432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Xyn_hzBwIcRAODkPRBKsLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_80898d8b-5c70-4956-9d84-bc6d044cd244",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Cosentino's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8051 W 160th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Organic grocery store with a bakery and a prepared foods department.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-3b11-76f0-88d8-37d170254566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-3b11-76f0-88d8-37d170254566",
        "storage_key": "property/6767906449167619/019fc993-3b11-76f0-88d8-37d170254566.webp",
        "width": 1280,
        "height": 442
      },
      "poi_business_url": "http://www.cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14067113957641997955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market",
      "poi_latitude": "38.8379901",
      "poi_longitude": "-94.68468",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-647-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-945979665f6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-945979665f6c",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-945979665f6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqY6WShzBwIcRg84wHJ1tOMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f8ee71b6-8b29-4553-9f17-acb72467f7bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "7921 W 160th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-6282-74fe-9417-a235ed047dfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-6282-74fe-9417-a235ed047dfb",
        "storage_key": "property/6767906449167619/019fc993-6282-74fe-9417-a235ed047dfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tjmaxx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6609183361631191822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "38.8379246",
      "poi_longitude": "-94.6831446",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-239-0161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr_qpa-3BwIcRDgNzHUCJuFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_262bf926-5949-40ed-96a2-825321edeb62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "7840 W 161st St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-514c-779d-a9c2-ab6ef52ad80f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-514c-779d-a9c2-ab6ef52ad80f",
        "storage_key": "property/6767906449167619/019fc993-514c-779d-a9c2-ab6ef52ad80f.webp",
        "width": 724,
        "height": 431
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/3491",
      "poi_directions_map_url": "https://maps.google.com/?cid=14425624629717197688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "38.8378825",
      "poi_longitude": "-94.6805205",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-398-8103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-1oPZu3BwIcReGNrpSsdMsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_4e2f2998-1166-4728-9813-b4b51025d514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "7860 W 161st St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-52e1-73d8-97e8-a8acc1bfe743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-52e1-73d8-97e8-a8acc1bfe743",
        "storage_key": "property/6767906449167619/019fc993-52e1-73d8-97e8-a8acc1bfe743.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/overland-park-ks-1758",
      "poi_directions_map_url": "https://maps.google.com/?cid=1043660090848998133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.8379491",
      "poi_longitude": "-94.6817028",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-552-1858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUf2UIgbBwIcR9XJOtVLTew4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_1b808a7c-4654-441b-a7d5-38cf9f8b26c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Bath & Body Works",
      "poi_type": "Shopping & Retail",
      "poi_address": "7860 W 161st St Space J-105, Overland Park, KS 66223, USA",
      "poi_short_description": "Chain with housebrand lotions & soaps in a range of scents, plus candles & home fragrances.",
      "poi_long_description": "Chain with housebrand lotions & soaps in a range of scents, plus candles & home fragrances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-6d6b-7355-9430-84f4c1b24cd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-6d6b-7355-9430-84f4c1b24cd4",
        "storage_key": "property/6767906449167619/019fc993-6d6b-7355-9430-84f4c1b24cd4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bathandbodyworks.com/?cm_mmc=local_BBW02727",
      "poi_directions_map_url": "https://maps.google.com/?cid=16779478622024312266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bath--body-works",
      "poi_latitude": "38.8379491",
      "poi_longitude": "-94.6817028",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-905-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH8eRzRjBwIcRyiUFvueu3Og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_1663b651-39bc-4e16-821f-3ded74266b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Rack Room Shoes",
      "poi_type": "Shopping & Retail",
      "poi_address": "7860 W 161st St Suite J-102, Overland Park, KS 66223, USA",
      "poi_short_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_long_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-734e-775f-8a27-361d51f66be0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-734e-775f-8a27-361d51f66be0",
        "storage_key": "property/6767906449167619/019fc993-734e-775f-8a27-361d51f66be0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.rackroomshoes.com/store/1040?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=1040",
      "poi_directions_map_url": "https://maps.google.com/?cid=4830714111127222280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rack-room-shoes",
      "poi_latitude": "38.8379491",
      "poi_longitude": "-94.6817028",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-300-0806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF5umLwDBwIcRCHg0zeMkCkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_e430dc88-5f5a-4577-9552-c82935902e9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "The Plaid Elephant Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "7951 W 160th St Ste 530, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-1d13-772d-885b-941ae7c40fba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-1d13-772d-885b-941ae7c40fba",
        "storage_key": "property/6767906449167619/019ff6a3-1d13-772d-885b-941ae7c40fba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.theplaidelephantshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5532740548719556601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-plaid-elephant-shop",
      "poi_latitude": "38.8381159",
      "poi_longitude": "-94.6839855",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-318-0058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs10rSdHBwIcR-TfUIDc-yEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_94aa8085-f411-4e1c-83b6-d7c7afb43565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11701 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Department store chain with clothing, electronics, and home goods, plus groceries, and pharmacy services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-7beb-76fa-921c-2074e5d3740b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-7beb-76fa-921c-2074e5d3740b",
        "storage_key": "property/6767906449167619/01a0b66d-7beb-76fa-921c-2074e5d3740b.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1599-overland-park-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9310956249863213418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.91484750000001",
      "poi_longitude": "-94.6638388",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-338-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPwmyQxXqwIcRatFMsGApN4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9ef72344-eca7-44c3-a7b7-787a11dda42c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "12055 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-8628-706e-beb2-dd896c06ee2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-8628-706e-beb2-dd896c06ee2f",
        "storage_key": "property/6767906449167619/01a0b66d-8628-706e-beb2-dd896c06ee2f.webp",
        "width": 1280,
        "height": 998
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/overland-park/12055-metcalf-avenue/fk79",
      "poi_directions_map_url": "https://maps.google.com/?cid=3585268300803321011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.911418",
      "poi_longitude": "-94.665591",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-945979665f6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-945979665f6c",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-945979665f6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZIjWADrwIcRs6zZJYZuwTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d52e0b43-dc88-4ba5-892c-5f9ca9f0cc12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-8693-71cf-be43-686ef799ac95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-8693-71cf-be43-686ef799ac95",
        "storage_key": "property/6767906449167619/01a0b66d-8693-71cf-be43-686ef799ac95.webp",
        "width": 1280,
        "height": 669
      },
      "poi_business_url": "https://www.target.com/sl/overland-park/1757",
      "poi_directions_map_url": "https://maps.google.com/?cid=6931391453674116315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9076847",
      "poi_longitude": "-94.6750703",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-327-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9bf2c5bb56b7",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9bf2c5bb56b7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk4-I6W7qwIcR25Rsk80_MWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7b0853db-1e4f-465f-89b1-df3b87371e64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Cedar Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "9100 W 165th St, Overland Park, KS 66085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/CHE",
      "poi_directions_map_url": "https://maps.google.com/?cid=1145615460543569955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-hills-elementary-school",
      "poi_latitude": "38.8307119",
      "poi_longitude": "-94.6935603",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXWSjgt3AwIcRIyDlDjEL5g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ed01b525-4e0b-4c8a-902b-64b365ee4d76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Pleasant Ridge Middle School",
      "poi_type": "Education",
      "poi_address": "9000 W 165th St, Overland Park, KS 66085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/prm",
      "poi_directions_map_url": "https://maps.google.com/?cid=9333116059643875235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pleasant-ridge-middle-school",
      "poi_latitude": "38.8308115",
      "poi_longitude": "-94.692437",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1ZJKIN7AwIcRow-RdpvjhYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_feb9a9b6-b4cb-45d9-a95f-01b3387c791d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Blue Valley West High School",
      "poi_type": "Education",
      "poi_address": "16200 Antioch Rd, Overland Park, KS 66085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-2403-74be-adf7-22b3adbb17ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-2403-74be-adf7-22b3adbb17ee",
        "storage_key": "property/6767906449167619/019ff6a3-2403-74be-adf7-22b3adbb17ee.webp",
        "width": 1280,
        "height": 561
      },
      "poi_business_url": "http://www.bluevalleyk12.org/bvw",
      "poi_directions_map_url": "https://maps.google.com/?cid=16318928122563868217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-west-high-school",
      "poi_latitude": "38.8352247",
      "poi_longitude": "-94.6925195",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXZNzGuHAwIcROTaNhKp6eOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f40b8200-dc0d-4a9e-977f-64299a846586",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Primrose School of Blue Valley",
      "poi_type": "Education",
      "poi_address": "8300 W 165th St, Overland Park, KS 66085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-6347-72f7-b4e9-e78ce9fdd8af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-6347-72f7-b4e9-e78ce9fdd8af",
        "storage_key": "property/6767906449167619/019fc993-6347-72f7-b4e9-e78ce9fdd8af.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/blue-valley/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14496790582344154921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-blue-valley",
      "poi_latitude": "38.8316701",
      "poi_longitude": "-94.6844673",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-370-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzR37BCDBwIcRKf_ZMzryLsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_709c6e8e-8405-4ccb-8170-c91d43063a9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Kids 'R' Kids Learning Academy of Blue Valley",
      "poi_type": "Education",
      "poi_address": "7489 W 161st St, Overland Park, KS 66085, USA",
      "poi_short_description": "Daycare chain with tech-filled classrooms providing programs for infants through prekindergarteners.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-929a-739d-985e-a236128d3e8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-929a-739d-985e-a236128d3e8b",
        "storage_key": "property/6767906449167619/019fc993-929a-739d-985e-a236128d3e8b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://kidsrkids.com/overland-park/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4265288461237356163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-blue-valley",
      "poi_latitude": "38.8353416",
      "poi_longitude": "-94.6727676",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-298-8562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhaNo7xbBwIcRgwagzEFZMTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9405279d-91d6-4253-93b8-e62c6c6548fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Rasmussen University - Kansas City/Overland Park",
      "poi_type": "Education",
      "poi_address": "11600 College Blvd Ste 100, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-8cbd-712b-bda3-61393e002083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-8cbd-712b-bda3-61393e002083",
        "storage_key": "property/6767906449167619/01a0b66d-8cbd-712b-bda3-61393e002083.webp",
        "width": 1077,
        "height": 606
      },
      "poi_business_url": "https://www.rasmussen.edu/locations/kansas/kansas-city-overland-park/?utm_source=google&utm_medium=organic&utm_content=gbp-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11404219734160967595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rasmussen-university---kansas-cityoverland-park",
      "poi_latitude": "38.92787999999999",
      "poi_longitude": "-94.7198618",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-491-7870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI-go2dDqwIcRqwcqE23tQ54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_12147ce6-fc34-4e03-aa25-eedef269b781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-a1c0-73a3-b1a7-3ee5f6889b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-a1c0-73a3-b1a7-3ee5f6889b17",
        "storage_key": "property/6767906449167619/019fc993-a1c0-73a3-b1a7-3ee5f6889b17.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2d057359-cd93-4460-b491-05c217b48929",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Blue Valley School District Office #229",
      "poi_type": "Education",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12406361877646761667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-school-district-office-229",
      "poi_latitude": "38.8566433",
      "poi_longitude": "-94.6685552",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUYMDKHBwIcRw14VYGVALKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31b3e155-7330-4345-bafc-3743b0380b85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Blue Valley Center for Advanced Professional Studies",
      "poi_type": "Education",
      "poi_address": "7501 W 149th Terrace, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-348b-71ce-8dea-89b345be3ed2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-348b-71ce-8dea-89b345be3ed2",
        "storage_key": "property/6767906449167619/019ff6a3-348b-71ce-8dea-89b345be3ed2.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "http://www.bvcaps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11176141449272905891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-center-for-advanced-professional-studies",
      "poi_latitude": "38.8563867",
      "poi_longitude": "-94.6720955",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-239-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNejVJKHBwIcRo1BuM2-hGZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2f05cf51-1990-494f-9a93-f253053e4ed0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-79b9-753a-b5f9-a786d64906bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-79b9-753a-b5f9-a786d64906bc",
        "storage_key": "property/6767906449167619/019fc98c-79b9-753a-b5f9-a786d64906bc.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a8ba50a074d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a8ba50a074d6",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a8ba50a074d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f5bcc3e0-5816-4d0c-b99a-182e7e7634c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-c7c6-77fc-9402-7b59b67e1d78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-c7c6-77fc-9402-7b59b67e1d78",
        "storage_key": "property/6767906449167619/019fc993-c7c6-77fc-9402-7b59b67e1d78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-4144-77d8-ad2f-8bd9557f9d0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4144-77d8-ad2f-8bd9557f9d0c",
        "storage_key": "property/6767906449167619/019ff6a4-4144-77d8-ad2f-8bd9557f9d0c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_52eb61fc-bb2f-4362-a115-db052d09ec03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-916a-735d-ab8a-4c67e41eb893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-916a-735d-ab8a-4c67e41eb893",
        "storage_key": "property/6767906449167619/01a0b66d-916a-735d-ab8a-4c67e41eb893.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_f670704d-be18-42d1-8f5a-41bcd81d8aab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-7c11-7771-becb-b124d8643060.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-7c11-7771-becb-b124d8643060",
        "storage_key": "property/6767906449167619/019fc98c-7c11-7771-becb-b124d8643060.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ce6fb20b-fdbf-4003-87e0-da97dd2cbae8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "AdventHealth Sports Park at Bluhawk",
      "poi_type": "Entertainment",
      "poi_address": "16201 Shawnee Dr, Overland Park, KS 66223, USA",
      "poi_short_description": "Clean and huge event space featuring a bar, an ice rink and an arcade.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc994-9392-75df-843a-668ea3b9efc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-9392-75df-843a-668ea3b9efc3",
        "storage_key": "property/6767906449167619/019fc994-9392-75df-843a-668ea3b9efc3.webp",
        "width": 1280,
        "height": 776
      },
      "poi_business_url": "http://bluhawksports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7246307073718881549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-sports-park-at-bluhawk",
      "poi_latitude": "38.8347375",
      "poi_longitude": "-94.6808534",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-713-4295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt3aQ8SPBwIcRDQ1qFuQNkGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_38fb08ae-d1ce-4018-8a7c-0c85eab92ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-d308-7008-8965-1796a88447e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-d308-7008-8965-1796a88447e0",
        "storage_key": "property/6767906449167619/019fc993-d308-7008-8965-1796a88447e0.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a8ba50a074d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a8ba50a074d6",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a8ba50a074d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_725f4f68-1ae5-40a4-bea0-9e674e6bac7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-c364-716b-91d2-afabc78face5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-c364-716b-91d2-afabc78face5",
        "storage_key": "property/6767906449167619/019fc993-c364-716b-91d2-afabc78face5.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06e36a32-70c1-4695-8442-12bc81a763b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-ce28-74f4-9924-a9a842141ca8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-ce28-74f4-9924-a9a842141ca8",
        "storage_key": "property/6767906449167619/019fc98c-ce28-74f4-9924-a9a842141ca8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_22c69227-69a8-4ee2-9606-150252578f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-fe07-754e-b414-6633f1f5ffdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-fe07-754e-b414-6633f1f5ffdb",
        "storage_key": "property/6767906449167619/019fc993-fe07-754e-b414-6633f1f5ffdb.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6aed0907-3bc4-4fba-b78d-954c66c57cc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Dave & Buster's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6811 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-9877-72cd-a216-9ccff06aa962.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-9877-72cd-a216-9ccff06aa962",
        "storage_key": "property/6767906449167619/01a0b66d-9877-72cd-a216-9ccff06aa962.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2445764442989428663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-overland-park",
      "poi_latitude": "38.88149050000001",
      "poi_longitude": "-94.6652889",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-249-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2980-71dc-a2e9-dd71e090df1c",
        "storage_key": "property/6767906449167619/019fc98e-2980-71dc-a2e9-dd71e090df1c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVr1MujBwIcRt3-qfM0Z8SE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e3427fb2-a1e0-4d3b-9748-d64c3ee836c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "AdventHealth South Overland Park Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7820 W 165th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-ef8e-7312-8a5a-c666d109eac6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-ef8e-7312-8a5a-c666d109eac6",
        "storage_key": "property/6767906449167619/019fc993-ef8e-7312-8a5a-c666d109eac6.webp",
        "width": 1280,
        "height": 727
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-south-overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9373271053670540671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-south-overland-park-hospital",
      "poi_latitude": "38.83279230000001",
      "poi_longitude": "-94.6805835",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-373-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-134793a9f5cc",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQPX-BrBwIcRf-V7kVyMFII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4895adb3-7b2a-4f65-a02a-2a2cc308b02a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "AdventHealth Centra Care Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "9099 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-980a-7308-b85e-fe7739c82d0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-980a-7308-b85e-fe7739c82d0d",
        "storage_key": "property/6767906449167619/01a0b66d-980a-7308-b85e-fe7739c82d0d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://centracare.adventhealth.com/urgent-care/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16421499770594357393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-centra-care-overland-park",
      "poi_latitude": "38.8832467",
      "poi_longitude": "-94.6909065",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-549-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwRwCDLAwIcRkXBvWQnj5OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3bd05974-1fc9-4b14-9214-6e8f3d4a6b8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Cosentino's Market Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8051 W 160th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-5eba-71ca-ae99-6b8a68a151db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-5eba-71ca-ae99-6b8a68a151db",
        "storage_key": "property/6767906449167619/019ff6a3-5eba-71ca-ae99-6b8a68a151db.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "http://www.cosentinosmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12687025949466859183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market-pharmacy",
      "poi_latitude": "38.8378989",
      "poi_longitude": "-94.6846759",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-647-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-412c-716a-99be-73975a404c20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-412c-716a-99be-73975a404c20",
        "storage_key": "property/6767906449167619/019ff6a4-412c-716a-99be-73975a404c20.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdA1fWHBwIcRr5Yi3uFeEbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_05715565-acd8-4cd8-811e-86e364911e52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7100 W 151st St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-987e-764a-b997-83845fda2ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-987e-764a-b997-83845fda2ddc",
        "storage_key": "property/6767906449167619/01a0b66d-987e-764a-b997-83845fda2ddc.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/7100-w-151st-street-overland-park-ks-66223/storeid=8586?WT.mc_id=LS_GOOGLE_RX_8586",
      "poi_directions_map_url": "https://maps.google.com/?cid=7580047498109267594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.8552427",
      "poi_longitude": "-94.6685482",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-681-3950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-412c-716a-99be-73975a404c20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-412c-716a-99be-73975a404c20",
        "storage_key": "property/6767906449167619/019ff6a4-412c-716a-99be-73975a404c20.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRUSZ_qDBwIcRii5k6Qm9MWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_517e60ce-a9fd-4488-b692-4c51f2910d22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8450 W 151st St, Overland Park, KS 66223, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc994-16e8-72d0-b36e-18df09192648.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-16e8-72d0-b36e-18df09192648",
        "storage_key": "property/6767906449167619/019fc994-16e8-72d0-b36e-18df09192648.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8450+w+151st+st-overland+park-ks-66223/id=4221",
      "poi_directions_map_url": "https://maps.google.com/?cid=3775313337847789287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.8550933",
      "poi_longitude": "-94.6854081",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-814-7977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-412c-716a-99be-73975a404c20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-412c-716a-99be-73975a404c20",
        "storage_key": "property/6767906449167619/019ff6a4-412c-716a-99be-73975a404c20.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73ZNIavBwIcR5zY2cnqbZDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ce3f22e4-4e34-4f2d-892d-f1d6a97b17b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Jazzercise/Stanley/South Overland Park Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "15185 Lowell Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-9aed-723a-bc16-93e0a5c1e7c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-9aed-723a-bc16-93e0a5c1e7c3",
        "storage_key": "property/6767906449167619/01a0b66d-9aed-723a-bc16-93e0a5c1e7c3.webp",
        "width": 1280,
        "height": 759
      },
      "poi_business_url": "http://www.jazzercise.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10321814943115973031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jazzercisestanleysouth-overland-park-fitness-center",
      "poi_latitude": "38.8528627",
      "poi_longitude": "-94.6780699",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-486-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7-XLqjBwIcRpxG_4QB0Po8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4fe4cba8-4269-4992-90fa-69021e6bb209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "14820 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-59ef-75a8-ac5d-6465a1f47973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-59ef-75a8-ac5d-6465a1f47973",
        "storage_key": "property/6767906449167619/019ff6a3-59ef-75a8-ac5d-6465a1f47973.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/overland-park-kansas-4279/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4279",
      "poi_directions_map_url": "https://maps.google.com/?cid=367115245637323564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "38.859691",
      "poi_longitude": "-94.6683271",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-222-8082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOxZYS6LBwIcRLMvX715BGAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b98b4f3b-3296-452e-a79c-48d191ca61c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "BODYBAR Pilates - South Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "13340 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Studio offering Reformer Pilates classes in a supportive environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-9fe2-72d0-b8db-aaa851b5119d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-9fe2-72d0-b8db-aaa851b5119d",
        "storage_key": "property/6767906449167619/01a0b66d-9fe2-72d0-b8db-aaa851b5119d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bodybarpilates.com/studios/south-overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11674532637011088714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodybar-pilates---south-overland-park",
      "poi_latitude": "38.8861138",
      "poi_longitude": "-94.6691952",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-907-0904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-a61a765d9daf",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-a61a765d9daf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwQBFDgDBwIcRShXAO5RFBKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_5ad5d451-37a3-479a-b54c-bbfca141f0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13621 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Heart rate–based, calorie-burning studio featuring group classes and workouts that can be tracked in real-time.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0100b-3cdd-70a3-9dde-538104acd105.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100b-3cdd-70a3-9dde-538104acd105",
        "storage_key": "property/6767906449167619/01a0100b-3cdd-70a3-9dde-538104acd105.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas/overland-park/13621-metcalf-ave/?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2517780848240473361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.8814048",
      "poi_longitude": "-94.6672773",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-213-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2AK5sLBwIcREbWneVf08CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c328c7f8-9875-4f06-9036-114fa59e9a83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 138th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale gym with a spa, an indoor and an outdoor pool, plus a hair salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-7d4f-7338-a085-192ff258a366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-7d4f-7338-a085-192ff258a366",
        "storage_key": "property/6767906449167619/019fc98c-7d4f-7338-a085-192ff258a366.webp",
        "width": 1200,
        "height": 627
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/overland-park?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007822183813280658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.8789466",
      "poi_longitude": "-94.6645722",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-239-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyRfIerBwIcRkvPmA3ISYFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f48b60d1-8a8a-46a6-a796-04d1d8d23200",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Tomahawk Ridge Community Center",
      "poi_type": "Entertainment",
      "poi_address": "11902 Lowell Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Community center featuring a pool, gym, and weight room, plus basketball and pickleball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-9c6d-728d-997c-b30e0626519c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-9c6d-728d-997c-b30e0626519c",
        "storage_key": "property/6767906449167619/01a0b66d-9c6d-728d-997c-b30e0626519c.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/community-centers/tomahawk-ridge-community-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15649488985071822842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-ridge-community-center",
      "poi_latitude": "38.9123206",
      "poi_longitude": "-94.6781525",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-327-6644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAecTi2bqwIcR-ieYP1EnLtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_bb9de587-8d86-4745-a6bd-52c879689a32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Tomahawk Ridge Aquatic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11950 Lowell Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Seasonal outdoor pool featuring fountains, diving boards, 2 waterslides, lap lanes & picnic space.",
      "poi_long_description": "Seasonal outdoor pool featuring fountains, diving boards, 2 waterslides, lap lanes & picnic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-9d30-7279-b517-c1eee7a09200.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-9d30-7279-b517-c1eee7a09200",
        "storage_key": "property/6767906449167619/01a0b66d-9d30-7279-b517-c1eee7a09200.webp",
        "width": 1280,
        "height": 797
      },
      "poi_business_url": "https://www.opkansas.gov/tomahawk-ridge-aquatic-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3430483308782573870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-ridge-aquatic-center",
      "poi_latitude": "38.9100676",
      "poi_longitude": "-94.6777457",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-327-5675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwwhd2bqwIcRLlnk02SGmy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_04feb4cd-8b4f-4ecc-8d3e-f397a9125ea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Regency Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14800 Lamar Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Playground, swings and slides at this chill park featuring a lake and walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc994-4aee-7309-b091-0415c89e89db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-4aee-7309-b091-0415c89e89db",
        "storage_key": "property/6767906449167619/019fc994-4aee-7309-b091-0415c89e89db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463142209822193210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-lake-park",
      "poi_latitude": "38.8596074",
      "poi_longitude": "-94.6614219",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-1564982efdf5",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQkARJnBwIcROvbMn-kdmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f8fda0a9-e9a9-4a71-987a-1a2b3cad93c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16050 Pflumm Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Vast park with an 18-hole golf course, athletic fields, a dog off-leash area, and a 40-acre lake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-d9f1-722c-9808-f485af7cc4f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-d9f1-722c-9808-f485af7cc4f4",
        "storage_key": "property/6767906449167619/019fc98c-d9f1-722c-9808-f485af7cc4f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcprd.com/Facilities/Facility/Details/Heritage-Park-22",
      "poi_directions_map_url": "https://maps.google.com/?cid=9628716837042979252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "38.8308502",
      "poi_longitude": "-94.7528206",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-888-4713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-1564982efdf5",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVvVbW6_wIcRtAHFuvISoIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6d9b378-c5ec-45f1-b0d8-0951991b59e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Lake Olathe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 S Lakeshore Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a beach, an obstacle course, a waterfall and cliffs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-9de6-70ec-a9b1-96522966aeca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-9de6-70ec-a9b1-96522966aeca",
        "storage_key": "property/6767906449167619/01a0b66d-9de6-70ec-a9b1-96522966aeca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/lake-olathe-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6997584864379487297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-olathe-park",
      "poi_latitude": "38.8735242",
      "poi_longitude": "-94.8731186",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 913-971-8973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-1564982efdf5",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZtehEK9wIcRQUT9_ltqHGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_00da5682-6a39-4444-8168-f0c92e156f11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Black Bob Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14500 W 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_long_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a01007-ef34-7144-a736-fbe7906b22ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01007-ef34-7144-a736-fbe7906b22ae",
        "storage_key": "property/6767906449167619/01a01007-ef34-7144-a736-fbe7906b22ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/black-bob-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317087441858333318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-bob-park",
      "poi_latitude": "38.8583619",
      "poi_longitude": "-94.7539901",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-1564982efdf5",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTqNmKS_wIcRhgoMG4_Nqlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_90cd7f1e-183c-43ae-807c-6d1c57e079f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Corporate Woods Founders Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9300 Indian Creek Pkwy, Overland Park, KS 66210, USA",
      "poi_short_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_long_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-a24f-707f-a7e6-f416e3440ee7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-a24f-707f-a7e6-f416e3440ee7",
        "storage_key": "property/6767906449167619/01a0b66d-a24f-707f-a7e6-f416e3440ee7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/corporate-woods-founders-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14583573077730300202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-founders-park",
      "poi_latitude": "38.933341",
      "poi_longitude": "-94.6949701",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-1564982efdf5",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05niK_3qwIcRKpEQdnJCY8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8ff1db63-6bb6-40e6-bea9-b4b5d4e4b2ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Thomas S. Stoll Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_long_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-a555-779e-8ab4-735c3903f2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-a555-779e-8ab4-735c3903f2d6",
        "storage_key": "property/6767906449167619/01a0b66d-a555-779e-8ab4-735c3903f2d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jcprd.com/parks_facilities/stoll_park.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11904290777782419563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-s-stoll-memorial-park",
      "poi_latitude": "38.9133269",
      "poi_longitude": "-94.7313061",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-1564982efdf5",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-1564982efdf5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06uvXjSVwIcRawCuCGSJNKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7189fdfa-41b5-4f4c-bf59-885d6d5ca692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-40dc-71a8-bd56-c99acee423af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40dc-71a8-bd56-c99acee423af",
        "storage_key": "property/6767906449167619/019ff6a4-40dc-71a8-bd56-c99acee423af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_d9d1d34d-3e6d-452e-952e-3dedf92365f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc994-c278-74d9-a749-e2acc6dcb41b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-c278-74d9-a749-e2acc6dcb41b",
        "storage_key": "property/6767906449167619/019fc994-c278-74d9-a749-e2acc6dcb41b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0feaef6a-b3a3-4b40-b18d-712719c57d46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "15.1",
      "poi_walking_minutes": "5 hours 35 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-40dc-71a8-bd56-c99acee423af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40dc-71a8-bd56-c99acee423af",
        "storage_key": "property/6767906449167619/019ff6a4-40dc-71a8-bd56-c99acee423af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_c93582df-6b75-4d4c-bd76-bf91280c9af6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Shawnee Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "15205 W 63rd St, Shawnee, KS 66217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-a1da-71a1-8be9-4af2716dc297.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-a1da-71a1-8be9-4af2716dc297",
        "storage_key": "property/6767906449167619/01a0b66d-a1da-71a1-8be9-4af2716dc297.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shawneestation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10589385567007713794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-station",
      "poi_latitude": "39.013604",
      "poi_longitude": "-94.7625242",
      "poi_miles_from_property": "16.4",
      "poi_walking_minutes": "6 hours 6 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-40dc-71a8-bd56-c99acee423af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40dc-71a8-bd56-c99acee423af",
        "storage_key": "property/6767906449167619/019ff6a4-40dc-71a8-bd56-c99acee423af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJOd4JSQKTwIcRAqokdxEO9ZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_06f055b5-896b-4a50-921e-75863c6e6607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "City of Lenexa - City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17101 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-a42e-74df-b343-140cc8bec4ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-a42e-74df-b343-140cc8bec4ba",
        "storage_key": "property/6767906449167619/01a0b66d-a42e-74df-b343-140cc8bec4ba.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.lenexa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5094475210756960245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-lenexa---city-hall",
      "poi_latitude": "38.9698667",
      "poi_longitude": "-94.7843444",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-477-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-40dd-7038-8bc4-8c4e0ad024bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40dd-7038-8bc4-8c4e0ad024bc",
        "storage_key": "property/6767906449167619/019ff6a4-40dd-7038-8bc4-8c4e0ad024bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo15EEKuUwIcR9a8zZjY2s0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_1bfec5fb-9762-4911-84c7-a10fcf5b8bf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc994-fd80-77ee-b609-0021d712ed87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-fd80-77ee-b609-0021d712ed87",
        "storage_key": "property/6767906449167619/019fc994-fd80-77ee-b609-0021d712ed87.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "43.4",
      "poi_walking_minutes": "16 hours 8 mins",
      "poi_biking_minutes": "4 hours 37 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-4c97-7097-b156-8f354a6ce5db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-4c97-7097-b156-8f354a6ce5db",
        "storage_key": "property/6767906449167619/019fc98e-4c97-7097-b156-8f354a6ce5db.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_de9c4e2f-663a-4afb-874f-0e5efeaceb5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-b3f0-778b-93b8-7713474f1a04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-b3f0-778b-93b8-7713474f1a04",
        "storage_key": "property/6767906449167619/019fc98c-b3f0-778b-93b8-7713474f1a04.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-134793a9f5cc",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_3f503407-6db4-4d19-9317-c8df8bbe4f42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc993-e3c3-700e-aabb-d99ebf965886.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-e3c3-700e-aabb-d99ebf965886",
        "storage_key": "property/6767906449167619/019fc993-e3c3-700e-aabb-d99ebf965886.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-134793a9f5cc",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4ffeabb8-94ff-4248-809c-b7f0fb71af6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Menorah Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98c-b72c-744c-a4d5-b06d8444938b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-b72c-744c-a4d5-b06d8444938b",
        "storage_key": "property/6767906449167619/019fc98c-b72c-744c-a4d5-b06d8444938b.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/menorah-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13288974551408218760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menorah-medical-center",
      "poi_latitude": "38.9108041",
      "poi_longitude": "-94.6515422",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-498-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-134793a9f5cc",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9T6FxnqwIcRiJLkTfLra7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_24050dd3-9a2c-471f-9180-f85146b3a3a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-aa0c-71a8-81c9-af007d59052e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-aa0c-71a8-81c9-af007d59052e",
        "storage_key": "property/6767906449167619/01a0b66d-aa0c-71a8-81c9-af007d59052e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-29d9-766e-b60e-134793a9f5cc",
        "storage_key": "property/6767906449167619/019fc98e-29d9-766e-b60e-134793a9f5cc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4d439eba-4eb7-4480-a303-59d7585ec385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-9f73-71bd-9a9e-ec2199a7ab89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-9f73-71bd-9a9e-ec2199a7ab89",
        "storage_key": "property/6767906449167619/019ff6a3-9f73-71bd-9a9e-ec2199a7ab89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0f2bfcf7-00f3-438d-abb0-3a27019bed67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc995-2b8d-72b3-8137-d51c8675bbb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-2b8d-72b3-8137-d51c8675bbb8",
        "storage_key": "property/6767906449167619/019fc995-2b8d-72b3-8137-d51c8675bbb8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9703371d-b125-41dc-90db-c4a11b219030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc995-5824-732b-af50-b75ff8ff6e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-5824-732b-af50-b75ff8ff6e89",
        "storage_key": "property/6767906449167619/019fc995-5824-732b-af50-b75ff8ff6e89.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_49d52368-ad1c-4cb2-94de-fffe5660ea31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Corporate Woods Office Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8717 W 110th St Ste 240, Overland Park, KS 66210, USA",
      "poi_short_description": "Business center featuring 29 buildings and ample parking, plus a trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b66d-acde-750f-a809-d0794986509b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66d-acde-750f-a809-d0794986509b",
        "storage_key": "property/6767906449167619/01a0b66d-acde-750f-a809-d0794986509b.webp",
        "width": 828,
        "height": 315
      },
      "poi_business_url": "http://www.corporatewoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514230223847482340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-office-park",
      "poi_latitude": "38.9282565",
      "poi_longitude": "-94.6879131",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-451-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98e-2981-71ca-b8e5-9e771d929428",
        "storage_key": "property/6767906449167619/019fc98e-2981-71ca-b8e5-9e771d929428.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-FZjPjqwIcR5OP6TxFX5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_3d6c81a5-7916-4d08-b3bd-2b6d148e1b57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a3-a55a-772d-a74a-a0e97bffa6a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-a55a-772d-a74a-a0e97bffa6a6",
        "storage_key": "property/6767906449167619/019ff6a3-a55a-772d-a74a-a0e97bffa6a6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/019ff6a4-40dd-7038-8bc4-8c4e0ad024bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40dd-7038-8bc4-8c4e0ad024bc",
        "storage_key": "property/6767906449167619/019ff6a4-40dd-7038-8bc4-8c4e0ad024bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3557ff9473f62a7fcaac7121",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_01f92573ccab67586e5c7243",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f141dfb3e1b24a4c33fefc92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_26df79145ec2edc252e1aabd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d2a52ba7ef0fcd17fb54286a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ab994c76c430e16b9e38d951",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_cc8e1c42-5d99-4740-a78e-b08b27bfdc01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "rating": "5.0",
      "name": "Jackson Everhart",
      "text": "We’ve lived here for about a year and have really loved it. The apartments are well-built and feel high quality, which you don’t always find. Management is always quick to respond and easy to work with, and maintenance has been great anytime we’ve needed something.\nOverall, it’s a wonderful property and definitely deserves five stars. If you’re looking for an apartment, this is a great place to live.",
      "date": "2026-03-31",
      "title": "false"
    },
    {
      "id": "custom_31e4bdc1-2d3e-4511-b198-607d23a4d22a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "rating": "5.0",
      "name": "Olivia Scroggins",
      "text": "We love it here! We previously lived at another price brothers property for a couple years before moving here and we made the right choice to stay in the price brothers community. They have a lot of amazing event that they host for us and even bigger events hosted in the shopping area and at advent sports park right next to Bluhawk! There is always something to do for me and my family that is close to home. The maintenance staff is very quick to get any work orders that we out in and the office staff is very welcoming to our family every time we step foot into the office.",
      "date": "2026-01-12",
      "title": ""
    },
    {
      "id": "custom_01ebb4ba-55f5-467a-9c7a-b1387df29407",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "rating": "5.0",
      "name": "Valeria Vasquez",
      "text": "We’ve been living in this community for two and a half years, and it truly is a wonderful place to live. The apartments are modern, with impeccable finishes that really make a difference. The office and maintenance staff are always very friendly and efficient in their work, which makes everything much easier and more comfortable. The community itself is fantastic, with friendly neighbors and a very welcoming atmosphere; without a doubt, they are the best in the area. :)",
      "date": "2025-03-13",
      "title": ""
    },
    {
      "id": "custom_c6b21d7c-a3da-4094-8794-d393e598f502",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "rating": "5.0",
      "name": "Cole Rouse",
      "text": "I had the pleasure of living here for just over two years, and it exceeded all my expectations. The apartments are thoughtfully designed with modern finishes, spacious layouts, and an abundance of natural light that creates a warm and inviting atmosphere. My unit was equipped with high-quality appliances and had ample storage space, making daily living incredibly convenient.\n\nThe management team is exceptional. Savannah is the BEST property manager, no comparison to anyone else. Mikayla is attentive, caring, and extremely understanding. Ella Grace is sweet, efficient, caring, and respectful! Management are always attentive, prompt, and go out of their way to ensure residents are comfortable and any issues are resolved swiftly. The maintenance staff is equally impressive, responding quickly to requests and keeping the property in pristine condition.\n\nLocation-wise, Bluhawk is unbeatable. It's conveniently situated near shopping centers, restaurants, parks, and walking trails, making it easy to access everything I needed. The neighborhood is safe and serene, providing a peaceful retreat from the hustle and bustle of city life.\n\nOverall, my experience was phenomenal! It truly felt like home, and I would highly recommend this complex to anyone seeking a comfortable, stylish, and well-maintained living environment.",
      "date": "2024-07-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_bedd7f99bf929845f6b89c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "The Essex floor plan at The Residences at Bluhawk: 3 Bed | 2 Bath | 1,563 sq. ft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-f1c5-741d-bff7-af7c781d5569.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b672-f1c5-741d-bff7-af7c781d5569",
        "storage_key": "property/6767906449167619/01a0b672-f1c5-741d-bff7-af7c781d5569.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "ESSEX",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pZ8Rcap3ycv"
    },
    {
      "id": "ec_838d7638fccd6ec3de548022",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-f60a-75d9-a106-52f81332909f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b672-f60a-75d9-a106-52f81332909f",
        "storage_key": "property/6767906449167619/01a0b672-f60a-75d9-a106-52f81332909f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "ASTORIA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WaBd9uiZ18V"
    },
    {
      "id": "ec_d956af45835095781c61d241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "The Residences at Bluhawk - Berkshire - 2 bed, 2 bath, 1,163 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-f8da-757e-85ad-65e00924208a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b672-f8da-757e-85ad-65e00924208a",
        "storage_key": "property/6767906449167619/01a0b672-f8da-757e-85ad-65e00924208a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "BERKSHIRE",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KhQTGX5bd5F"
    },
    {
      "id": "ec_a90a0d928816ce621483be5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Stratton - 2 bed, 2 bath, 1,202 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b673-03de-7339-9b13-a4262c575987.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b673-03de-7339-9b13-a4262c575987",
        "storage_key": "property/6767906449167619/01a0b673-03de-7339-9b13-a4262c575987.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "STRATTON",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tM4czahN9L9"
    },
    {
      "id": "ec_e50cfbc43f3be0131f59cdd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b672-f11d-7508-b1af-7e97168e149b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b672-f11d-7508-b1af-7e97168e149b",
        "storage_key": "property/6767906449167619/01a0b672-f11d-7508-b1af-7e97168e149b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "HAMPSHIRE",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FmBSZKUnYBu"
    },
    {
      "id": "ec_2f1d30ee65213780d1520363",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "The Residences at Bluhawk - Wellington - 1 bed, 1 bath, 787 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167619/01a0b673-2595-772a-8e9d-f0b5229cedff.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b673-2595-772a-8e9d-f0b5229cedff",
        "storage_key": "property/6767906449167619/01a0b673-2595-772a-8e9d-f0b5229cedff.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "WELLINGTON",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=obS6eKzZ2Hq"
    }
  ],
  "faqs": [
    {
      "id": "custom_0fef7371-942a-4f7f-9bab-1b6b94d429db",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_72135ce4-74ee-4799-98ad-d9492ab79020",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_fa4c4e29-60e7-404f-9691-cc64a8306c98",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3afcdce5-4893-4817-ab4b-dcdf23c40e4d",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_fff97a92-5b22-4505-a3ae-9f54b84c49a1",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_41c42374-0f50-4f77-909b-ffe2a9b29d7c",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8bad8871-64d7-44bf-ba40-e9d614bada1d",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1d8e2498-8cfc-4850-ab18-790067c66d51",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for electric, water, and trash.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1c51ecaf-93e0-4ccf-99b5-60130832534a",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_422c396e-d1c1-45a7-a16d-b4f052cc64c4",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_38cdfa35-e964-4373-b830-6e30fcfd9c86",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_93cba515-fa17-4939-8767-c12618f80c93",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_6edd249c-a12c-4366-ac9a-c1f966f20bfb",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_69686082-ba96-4182-a91d-0ab49c1f679d",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer detached garages and carports. Please <a href=\"/contact-us\">contact the office</a> for our most current availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d7c1c477-2309-4b6a-85ab-daf467acc9a4",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_aea77ef5-8f9a-4df3-bbc6-442c23ee713f",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_12f61038-d302-40f1-9c71-9c147aed49a1",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4d07-7519-bcb8-a0b4528c2122",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Residences at Bluhawk Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619"
    },
    {
      "lead_collector_id": "01a0c9ac-4d8a-714e-9c20-c58f2a0cc073",
      "lead_source": "LANDING_PAGE",
      "name": "The Residences at Bluhawk Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-overland-park-ks",
      "search_query": "in-unit laundry apartments Overland Park KS",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Overland Park KS",
      "h2_subtitle": "Discover in-unit laundry apartments at The Residences at Bluhawk. Enjoy modern amenities in the heart of Overland Park, KS.",
      "page_copy": "Experience the ultimate in convenience with in-unit laundry apartments at The Residences at Bluhawk in vibrant South Overland Park. Our spacious one-, two-, and three-bedroom homes offer everything you need, complete with the luxury of in-unit laundry facilities. Nestled within the bustling Bluhawk development, our community ensures you are never far from shopping and entertainment options. \n\nLiving at The Residences at Bluhawk means enjoying not only the ease of in-unit laundry but also a host of impressive amenities. With air conditioning, stylish faux wood blinds, and a dedicated pickleball court, you'll find both comfort and recreation right at your doorstep. Located in Outlying Johnson County KS, our community welcomes you to a lifestyle filled with ease and excitement.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Overland Park KS",
      "seo_description": "Find in-unit laundry apartments at The Residences at Bluhawk in Overland Park, KS. Enjoy modern living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-johnson-county",
      "search_query": "apartments with air conditioning Johnson County",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Johnson County",
      "h2_subtitle": "Stay cool in Johnson County with our air-conditioned apartments. Comfort and convenience await at The Residences at Bluhawk.",
      "page_copy": "Discover a refreshing lifestyle with apartments featuring air conditioning at The Residences at Bluhawk, located in South Overland Park within Johnson County. Our selection of one-, two-, and three-bedroom homes provides spacious living, tailored with modern comforts and polished finishes. Situated in the lively Bluhawk development, you'll have immediate access to various shopping and entertainment options. \n\nAlongside the comfort of air conditioning, residents enjoy an array of amenities designed for modern living, including stylish 2-inch faux wood blinds, a handicap-friendly environment, and an engaging pickleball court. Positioned in Outlying Johnson County KS, The Residences at Bluhawk combines contemporary convenience with unmatched location, ideal for anyone wanting a cool retreat from the Kansas heat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Johnson County",
      "seo_description": "Explore air-conditioned apartments at The Residences at Bluhawk, Johnson County. Offering modern amenities and prime convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-overland-park",
      "search_query": "dog-friendly apartments Overland Park",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Overland Park",
      "h2_subtitle": "Embrace pet-friendly living at The Residences at Bluhawk. Our Overland Park community welcomes you and your furry friends.",
      "page_copy": "Welcome home to dog-friendly apartments at The Residences at Bluhawk in South Overland Park. Our community is designed to accommodate both you and your furry companions, with ample living space across our one-, two-, and three-bedroom homes. Situated within the bustling Bluhawk shopping and entertainment district, our location offers convenience and vibrant surroundings. \n\nAt The Residences at Bluhawk, pet owners can enjoy the delight of living in a community that understands the importance of accommodating beloved pets. In addition to being dog-friendly, our residents benefit from a suite of amenities, including air conditioning, handicap access, and a community pickleball court. Discover a pet-friendly haven in Outlying Johnson County KS, offering a perfect blend of comfort and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Overland Park",
      "seo_description": "Live in dog-friendly comfort at The Residences at Bluhawk, Overland Park. Enjoy a pet-friendly community with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "gourmet-kitchens-apartments-near-bluhawk",
      "search_query": "gourmet kitchens apartments near Bluhawk",
      "category": "Amenity",
      "h1_title": "Gourmet Kitchens Apartments Near Bluhawk",
      "h2_subtitle": "Explore apartments with gourmet kitchens near Bluhawk. The Residences at Bluhawk offers upscale living in Overland Park, KS.",
      "page_copy": "Indulge in the luxury of gourmet kitchens at The Residences at Bluhawk, conveniently located near the vibrant Bluhawk shopping and entertainment district. Our one-, two-, and three-bedroom apartment homes are designed with culinary enthusiasts in mind, featuring state-of-the-art kitchens equipped with everything you need to create culinary delights. \n\nLiving at The Residences at Bluhawk means more than just an upscale kitchen. Residents enjoy a range of community amenities including air conditioning, handicap accessibility, faux wood blinds, and a lively pickleball court. Positioned in the heart of South Overland Park, our apartments offer a dynamic lifestyle with easy access to dining, shopping, and entertainment in Outlying Johnson County KS. Experience exceptional living where convenience meets luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gourmet Kitchens Apartments Near Bluhawk",
      "seo_description": "Discover gourmet kitchens at The Residences at Bluhawk, Overland Park. Enjoy upscale apartments with top amenities near the Bluhawk district.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "washer-dryer-included-rentals-66085",
      "search_query": "washer and dryer included rentals 66085",
      "category": "Amenity",
      "h1_title": "Washer & Dryer Included Rentals in 66085",
      "h2_subtitle": "Find rentals with washer and dryer included in the 66085 area. Enjoy hassle-free living at The Residences at Bluhawk.",
      "page_copy": "Enjoy the convenience of washer and dryer included rentals at The Residences at Bluhawk, situated in the 66085 ZIP code of South Overland Park. Our spacious one-, two-, and three-bedroom apartments offer an effortless living experience, combining modern conveniences with elegant finishes. Nestled in the bustling Bluhawk development, our community offers easy access to shopping and entertainment while catering to your living needs.\n\nThe Residences at Bluhawk ensures a streamlined lifestyle where laundry chores are a breeze with in-unit washer and dryers. Complementing this amenity, residents benefit from air conditioning, handicap accessibility, and a pickleball court for recreation. Located just outside Johnson County, KS, our community is the ideal choice for anyone seeking a balance of convenience, comfort, and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer & Dryer Rentals in 66085",
      "seo_description": "Explore rentals with washers and dryers included at The Residences at Bluhawk, 66085. Enjoy modern living with top amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-overland-park-ks",
      "search_query": "three bedroom apartments Overland Park KS",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Overland Park",
      "h2_subtitle": "Discover spacious three bedroom apartments in Overland Park, KS. The Residences at Bluhawk offers modern living with ample amenities.",
      "page_copy": "Experience comfortable and expansive living with our three bedroom apartments at The Residences at Bluhawk, located in the heart of Overland Park, KS. Our well-designed homes are perfect for families or roommates looking for ample space without compromising on style or convenience. Each apartment features polished finishes and modern layouts, providing a welcoming retreat.\n\nSet within the lively Bluhawk shopping and entertainment hub, our community offers an ideal location paired with desirable amenities including air conditioning, trash compactor, handicap accessibility, and a pickleball court. Whether you're commuting within Johnson County or enjoying the local South Overland Park attractions, The Residences at Bluhawk provides the perfect base to live comfortably and conveniently.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Overland Park",
      "seo_description": "Find spacious three bedroom apartments in Overland Park, KS at The Residences at Bluhawk. Enjoy luxury living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-outlying-johnson-county",
      "search_query": "two bedroom apartments near Outlying Johnson County KS",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Outlying Johnson",
      "h2_subtitle": "Explore two bedroom apartments near Outlying Johnson County, KS. The Residences at Bluhawk offers comfort and convenience for modern living.",
      "page_copy": "Discover the perfect two bedroom apartment at The Residences at Bluhawk, ideally situated near Outlying Johnson County, KS. Our thoughtfully designed homes provide ample living space along with contemporary finishes, making them an excellent choice for those in search of comfort and convenience. Enjoy the benefits of living in a vibrant community with direct access to the Bluhawk shopping and entertainment complex.\n\nResidents at The Residences at Bluhawk enjoy numerous amenities such as air conditioning, handicap accessibility, and stylish faux wood blinds. A lively pickleball court is available for recreation, all within the thriving environment of South Overland Park. Our two bedroom apartments promise a fulfilling lifestyle, balancing tranquility and access to urban advantages.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Outlying Johnson",
      "seo_description": "Find two bedroom apartments near Outlying Johnson County, KS at The Residences at Bluhawk. Experience comfort and convenience close to everything you need.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-johnson-county",
      "search_query": "one bedroom apartments in Johnson County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Johnson County",
      "h2_subtitle": "Find stylish one bedroom apartments in Johnson County, KS. The Residences at Bluhawk combines modern design with prime location benefits.",
      "page_copy": "Embrace modern living in Johnson County, KS with our stunning one bedroom apartments at The Residences at Bluhawk. Designed with your comfort in mind, these apartments feature polished finishes, making them a cozy and inviting choice for singles or couples looking to settle in a vibrant community. Located within the bustling Bluhawk development, these homes offer unparalleled convenience alongside a variety of on-site amenities.\n\nResidents enjoy air conditioning, a built-in trash compactor, and the elegance of 2-inch faux wood blinds, complemented by recreational perks like a community pickleball court. Our apartments' strategic placement in South Overland Park provides easy access to local shopping, dining, and entertainment venues, ensuring you thrive in both comfort and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Johnson County",
      "seo_description": "Explore one bedroom apartments in Johnson County, KS at The Residences at Bluhawk. Enjoy stylish design and convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-near-cedar-hills-elementary-overland-park",
      "search_query": "apartments near Cedar Hills Elementary School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Cedar Hills Elementary",
      "h2_subtitle": "Discover apartments near Cedar Hills Elementary School in Overland Park. The Residences at Bluhawk provides ideal living with a community focus.",
      "page_copy": "Located conveniently close to Cedar Hills Elementary School in Overland Park, The Residences at Bluhawk offer a vibrant living experience in a community-focused environment. Choose from a variety of spacious floor plans, including one, two, and three bedroom options, each crafted with premium finishes and thoughtful design. Our prime location ensures easy access to quality education alongside the vibrant lifestyle amenities offered at Bluhawk.\n\nEnjoy modern comforts with features like air conditioning, efficient trash compactors, and elegant faux wood blinds, paired with recreational amenities such as a pickleball court. Nestled within South Overland Park’s thriving Bluhawk shopping and entertainment district, our apartments provide a perfect blend of convenience and community engagement for families and individuals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cedar Hills Elementary School",
      "seo_description": "Find your home near Cedar Hills Elementary School in Overland Park at The Residences at Bluhawk. Enjoy community-focused living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "rentals-near-pleasant-ridge-middle-66085",
      "search_query": "rentals close to Pleasant Ridge Middle School 66085",
      "category": "School",
      "h1_title": "Rentals Close to Pleasant Ridge Middle School",
      "h2_subtitle": "Discover rentals close to Pleasant Ridge Middle School in the 66085 area. The Residences at Bluhawk offers a dynamic and convenient living experience.",
      "page_copy": "Experience the convenience of living near Pleasant Ridge Middle School in the 66085 ZIP code at The Residences at Bluhawk. Our spacious one-, two-, and three-bedroom rentals cater to families looking for quality living spaces with proximity to excellent education. Nestled in South Overland Park, these homes offer both comfort and accessibility within a thriving community.\n\nThe Residences at Bluhawk are equipped with modern amenities like air conditioning, handicap accessibility, and chic faux wood blinds. Residents enjoy additional on-site features such as a pickleball court, making leisure activities readily available. Being part of the dynamic Bluhawk shopping and entertainment development ensures easy access to dining, shopping, and entertainment, creating an enriched living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Pleasant Ridge Middle School",
      "seo_description": "Find rentals close to Pleasant Ridge Middle School in the 66085 area at The Residences at Bluhawk, offering comfortable and convenient living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-by-blue-valley-west-high-ks",
      "search_query": "apartments by Blue Valley West High School KS",
      "category": "School",
      "h1_title": "Apartments by Blue Valley West High School",
      "h2_subtitle": "Explore apartments conveniently located by Blue Valley West High School in KS. Enjoy a blend of education and modern living at The Residences at Bluhawk.",
      "page_copy": "The Residences at Bluhawk offer modern apartments situated near Blue Valley West High School, making it a perfect choice for families and students in KS. With our spacious one-, two-, and three-bedroom options, find the ideal living space tailored to your lifestyle needs. These homes come with top-tier finishes, providing comfort and style while being a stone's throw from excellent educational facilities.\n\nResidents enjoy community-focused amenities such as air conditioning, stylish 2-inch faux wood blinds, and a handy trash compactor. For recreation, the on-site pickleball court encourages fun and fitness close to home. Located in South Overland Park, our community is part of the bustling Bluhawk development, which offers convenient access to shopping, dining, and entertainment, ensuring a vibrant and convenient living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Blue Valley West High School KS",
      "seo_description": "Discover apartments by Blue Valley West High School in KS at The Residences at Bluhawk. Combining modern amenities with prime educational proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-near-rasmussen-university-overland-park",
      "search_query": "apartments near Rasmussen University Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Rasmussen University",
      "h2_subtitle": "Find charming apartments near Rasmussen University in Overland Park. Experience modern conveniences at The Residences at Bluhawk.",
      "page_copy": "Situated close to Rasmussen University, The Residences at Bluhawk offers a perfect blend of convenience and contemporary living for students and professionals in Overland Park. Choose from a range of one-, two-, and three-bedroom apartments, each designed with polished finishes to suit varied lifestyles. Our strategic location provides easy access to the university while offering the modern comforts and amenities that make daily life enjoyable.\n\nOur residents benefit from features like air conditioning, elegant 2-inch faux wood blinds, and handicap accessibility, promoting a comfortable living environment. Recreational facilities, including a pickleball court, make relaxation and fun readily available. Being part of the lively Bluhawk development means shopping, dining, and entertainment are just steps away, ensuring a dynamic living experience right next to Rasmussen University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rasmussen University",
      "seo_description": "Explore apartments near Rasmussen University in Overland Park at The Residences at Bluhawk. Enjoy modern amenities and convenient campus proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "rentals-around-johnson-county-community-college",
      "search_query": "rentals around Johnson County Community College",
      "category": "School",
      "h1_title": "Rentals Around Johnson County Community College",
      "h2_subtitle": "Explore rentals around Johnson County Community College. The Residences at Bluhawk offers convenience and comfort near campus in Overland Park.",
      "page_copy": "The Residences at Bluhawk offers ideal rentals for those wanting proximity to Johnson County Community College. Located in South Overland Park, our community provides spacious one-, two-, and three-bedroom options, perfect for students and staff seeking comfortable living accommodations around the college area. Each unit features high-quality finishes, combining style and practicality.\n\nResidents here enjoy noteworthy amenities including air conditioning and chic faux wood blinds, creating a welcoming home environment. Additionally, our pickleball court serves as a great spot for recreation and leisurely activities. Situated within the vibrant Bluhawk development, our rentals provide easy access to shopping, dining, and entertainment, ensuring you make the most of living near Johnson County Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Around Johnson County Community College",
      "seo_description": "Find rentals around Johnson County Community College at The Residences at Bluhawk in Overland Park, offering modern amenities and convenience near campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-by-blue-valley-caps-johnson-county",
      "search_query": "apartments by Blue Valley Center for Advanced Professional Studies Johnson County",
      "category": "School",
      "h1_title": "Apartments by Blue Valley CAPS Johnson County",
      "h2_subtitle": "Discover apartments by the Blue Valley Center for Advanced Professional Studies in Johnson County. Experience modern comfort at The Residences at Bluhawk.",
      "page_copy": "Positioned near the Blue Valley Center for Advanced Professional Studies (CAPS) in Johnson County, The Residences at Bluhawk offers a superb choice for those seeking quality apartments. With spacious layouts available in one-, two-, and three-bedroom formats, our homes are designed to accommodate a variety of needs, offering a comfortable living experience close to this innovative education center.\n\nOur community prides itself on providing excellent amenities such as air conditioning, stylish faux wood blinds, and an on-site pickleball court for recreation. The prime location within the Bluhawk development also means residents have access to a vibrant mix of shopping, dining, and entertainment options. Embrace modern living near the Blue Valley CAPS and enjoy the convenience and style that comes with it.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Blue Valley CAPS Johnson County",
      "seo_description": "Explore modern apartments by Blue Valley CAPS in Johnson County at The Residences at Bluhawk, combining style and convenience near this educational hub.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "residences-near-adventhealth-south-overland-park",
      "search_query": "residences near AdventHealth South Overland Park",
      "category": "Hospital",
      "h1_title": "Residences Near AdventHealth South Overland Park",
      "h2_subtitle": "Explore residences near AdventHealth South Overland Park. Experience stylish living at The Residences at Bluhawk with modern amenities and convenience.",
      "page_copy": "Located conveniently near AdventHealth South Overland Park, The Residences at Bluhawk offers the perfect mix of convenience and comfort. Our community features spacious one-, two-, and three-bedroom homes, ideal for healthcare professionals and families seeking a vibrant lifestyle close to the hospital. The contemporary apartments are designed with polished finishes and practical amenities that meet everyday needs.\n\nResidents enjoy features such as air conditioning, chic faux wood blinds, and a community pickleball court, enhancing the living experience. The location within the bustling Bluhawk development provides excellent access to shopping, dining, and entertainment, making daily errands and leisure activities effortless. Choose The Residences at Bluhawk for optimal living near AdventHealth South Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near AdventHealth South Overland Park",
      "seo_description": "Discover residences near AdventHealth South Overland Park at The Residences at Bluhawk, offering modern amenities and easy healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-close-to-overland-park-regional-medical-center",
      "search_query": "apartments close to Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Close to Overland Park Regional Medical",
      "h2_subtitle": "Discover apartments close to Overland Park Regional Medical Center. Enjoy modern living at The Residences at Bluhawk with exceptional amenities.",
      "page_copy": "If you're seeking apartments close to Overland Park Regional Medical Center, The Residences at Bluhawk is an excellent choice. Situated in South Overland Park, our community offers a selection of one-, two-, and three-bedroom homes designed to provide comfort and convenience for healthcare professionals and families alike.\n\nFeaturing amenities such as air conditioning, faux wood blinds, and a community pickleball court, our residences ensure a comfortable lifestyle. Located within the vibrant Bluhawk development, residents benefit from nearby shopping, dining, and entertainment options, making leisure and daily routines easy and enjoyable. Choose The Residences at Bluhawk for stylish and convenient living near the Overland Park Regional Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Overland Park Regional Medical",
      "seo_description": "Find apartments close to Overland Park Regional Medical Center at The Residences at Bluhawk, offering modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "family-apartments-by-childrens-mercy-kansas",
      "search_query": "family apartments by Children's Mercy Kansas",
      "category": "Hospital",
      "h1_title": "Family Apartments by Children's Mercy Kansas",
      "h2_subtitle": "Explore family apartments by Children's Mercy Kansas. Discover the comfort and convenience at The Residences at Bluhawk.",
      "page_copy": "Finding family apartments by Children's Mercy Kansas is easy with The Residences at Bluhawk. Our community is designed to offer family-friendly living spaces with one-, two-, and three-bedroom layouts that are perfect for families looking for comfort and convenience.\n\nEnjoy amenities that cater to all ages, including air conditioning for year-round comfort, chic faux wood blinds, and a pickleball court for recreation. Being part of the Bluhawk development, residents have quick access to an array of shops, restaurants, and entertainment venues, ensuring every family member can find something they love. Choose The Residences at Bluhawk for a harmonious family lifestyle near Children's Mercy Kansas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family Apartments by Children's Mercy Kansas",
      "seo_description": "Explore family apartments by Children's Mercy Kansas at The Residences at Bluhawk, offering spacious homes and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum-botanical-gardens",
      "search_query": "apartments near overland park arboretum & botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Find apartments near Overland Park Arboretum & Botanical Gardens. Live at The Residences at Bluhawk, blending comfort with nature's beauty.",
      "page_copy": "Discover nature-inspired living with apartments near the Overland Park Arboretum & Botanical Gardens at The Residences at Bluhawk. Situated in a vibrant South Overland Park community, our spacious one-, two-, and three-bedroom homes provide an excellent blend of modern living and natural beauty.\n\nResidents enjoy amenities such as air conditioning, stylish faux wood blinds, and a pickleball court, and also benefit from being close to the lush landscapes of the arboretum. The Bluhawk development offers an abundance of dining, shopping, and entertainment options, making it easy to enjoy both city conveniences and the serenity of nearby green spaces. Choose The Residences at Bluhawk for a balanced lifestyle close to Overland Park's natural treasures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum & Gardens",
      "seo_description": "Find nature-inspired living in apartments near Overland Park Arboretum & Botanical Gardens at The Residences at Bluhawk.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "residences-close-to-regency-lake-park-overland-park-ks",
      "search_query": "residences close to regency lake park overland park ks",
      "category": "Park",
      "h1_title": "Residences Near Regency Lake Park, Overland Park",
      "h2_subtitle": "Looking for residences close to Regency Lake Park in Overland Park, KS? Discover the perfect home at The Residences at Bluhawk.",
      "page_copy": "For those seeking residences close to Regency Lake Park in Overland Park, KS, The Residences at Bluhawk offers an ideal home. Our community provides a selection of spacious one-, two-, and three-bedroom apartments within a thriving neighborhood that combines convenience and recreation.\n\nAmenities such as air conditioning, faux wood blinds, and a charming pickleball court cater to your comfort and leisure needs. Located within the dynamic Bluhawk development, residents can enjoy a variety of shopping, dining, and entertainment options while being just a short drive from the serene landscapes of Regency Lake Park. Choose The Residences at Bluhawk for a lifestyle that perfectly mixes modern amenities with outdoor exploration.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Regency Lake Park, Overland Park",
      "seo_description": "Find residences close to Regency Lake Park in Overland Park, KS at The Residences at Bluhawk. Enjoy modern living and proximity to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-near-heritage-park-johnson-county",
      "search_query": "apartments near heritage park johnson county",
      "category": "Park",
      "h1_title": "Apartments Near Heritage Park, Johnson County",
      "h2_subtitle": "Explore apartments near Heritage Park in Johnson County. Experience comfort and convenience at The Residences at Bluhawk.",
      "page_copy": "If you're searching for apartments near Heritage Park in Johnson County, look no further than The Residences at Bluhawk. Our community is located in South Overland Park, within reach of the scenic landscapes of Heritage Park. We offer an array of spacious one-, two-, and three-bedroom apartment homes.\n\nAmenities include air conditioning for year-round comfort, modern faux wood blinds, and a welcoming pickleball court. Living at The Residences at Bluhawk means you’ll be part of the bustling Bluhawk district, where shopping, dining, and entertainment options abound, all while you remain close to the tranquility of Heritage Park. Enjoy a fulfilling lifestyle blending the best of urban convenience and natural beauty at our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Heritage Park, Johnson County",
      "seo_description": "Discover comfort at The Residences at Bluhawk, offering apartments near Heritage Park, Johnson County with easy access to nature and city amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-by-lake-olathe-park-overland-park-ks",
      "search_query": "apartments by lake olathe park overland park ks",
      "category": "Park",
      "h1_title": "Apartments by Lake Olathe Park, Overland Park",
      "h2_subtitle": "Discover apartments by Lake Olathe Park in Overland Park, KS. Experience living at The Residences at Bluhawk, where comfort meets nature.",
      "page_copy": "For those desiring apartments by Lake Olathe Park in Overland Park, KS, The Residences at Bluhawk is an exceptional choice. This vibrant community offers spacious one-, two-, and three-bedroom homes that are perfect for individuals and families alike.\n\nHere, you'll find modern amenities such as air conditioning, contemporary faux wood blinds, and a dedicated pickleball court, ensuring comfort and entertainment year-round. Located within the bustling Bluhawk development, residents enjoy a rich array of shopping, dining, and recreation experiences while having the serene Lake Olathe Park within accessible distance. Embrace the blend of suburban tranquility and urban convenience at The Residences at Bluhawk.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Lake Olathe Park, Overland Park",
      "seo_description": "Experience living at The Residences at Bluhawk, offering apartments by Lake Olathe Park, Overland Park, KS. Enjoy urban comfort with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "living-near-black-bob-park-overland-park",
      "search_query": "living near black bob park overland park",
      "category": "Park",
      "h1_title": "Living Near Black Bob Park, Overland Park",
      "h2_subtitle": "Explore living options near Black Bob Park in Overland Park. Discover your perfect home at The Residences at Bluhawk.",
      "page_copy": "For those considering living near Black Bob Park in Overland Park, The Residences at Bluhawk offers an ideal residential choice. Our community boasts a variety of one-, two-, and three-bedroom homes designed for modern living.\n\nResidents enjoy amenities like refreshing air conditioning, stylish faux wood blinds, and an engaging pickleball court. Nestled in the vibrant Bluhawk development, you'll find abundant shopping and dining options nearby while having the natural beauty of Black Bob Park just a short drive away. Experience a balanced lifestyle of comfort and outdoor adventures at The Residences at Bluhawk.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Black Bob Park, Overland Park",
      "seo_description": "Find your home at The Residences at Bluhawk, offering residences just a short drive from Black Bob Park, Overland Park. Enjoy city amenities and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-close-to-corporate-woods-founders-park",
      "search_query": "apartments close to corporate woods founders park johnson county",
      "category": "Park",
      "h1_title": "Apartments Close to Corporate Woods, Johnson County",
      "h2_subtitle": "Discover apartments close to Corporate Woods Founders Park in Johnson County. Enjoy luxury at The Residences at Bluhawk.",
      "page_copy": "When searching for apartments close to Corporate Woods Founders Park in Johnson County, consider The Residences at Bluhawk. Our community offers elegant one-, two-, and three-bedroom homes, perfect for those seeking comfort and convenience.\n\nWith amenities like air conditioning, chic faux wood blinds, and a pickleball court, residents have everything they need. Situated in the lively Bluhawk development, you're within easy reach of Corporate Woods and its serene park setting, while enjoying comprehensive retail and dining options just steps away. Make The Residences at Bluhawk your new home and relish in the blend of city life with the tranquility of nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Corporate Woods, Johnson County",
      "seo_description": "Live at The Residences at Bluhawk, offering apartments near Corporate Woods Founders Park, Johnson County. Enjoy easy access to parks and urban amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "residences-near-thomas-stoll-memorial-park",
      "search_query": "residences near thomas s. stoll memorial park outlying johnson county",
      "category": "Park",
      "h1_title": "Residences Near Thomas S. Stoll Memorial Park",
      "h2_subtitle": "Explore residences near Thomas S. Stoll Memorial Park in Outlying Johnson County. Discover life at The Residences at Bluhawk.",
      "page_copy": "If you're looking for residences near Thomas S. Stoll Memorial Park in Outlying Johnson County, The Residences at Bluhawk is your top choice. Offering spacious one-, two-, and three-bedroom homes, this community is designed to meet all your needs.\n\nOur location provides convenient access to the serene environment of Thomas S. Stoll Memorial Park, while amenities such as air conditioning, trendy faux wood blinds, and a sports-ready pickleball court enhance your everyday life. Nestled within the bustling Bluhawk development, you'll enjoy the perfect mix of nature and city living. Choose The Residences at Bluhawk for a harmonious residential experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Thomas S. Stoll Memorial Park",
      "seo_description": "Discover The Residences at Bluhawk, located near Thomas S. Stoll Memorial Park in Outlying Johnson County. Experience nature and urban comforts together.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167619",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Find comfortable apartments near Kansas City International Airport. Discover modern living at The Residences at Bluhawk.",
      "page_copy": "Searching for apartments near Kansas City International Airport? The Residences at Bluhawk in Overland Park offers a convenient location for frequent travelers. With easy access to the airport, residents enjoy the added benefit of a short commute.\n\nOur community offers a variety of one-, two-, and three-bedroom homes outfitted with modern amenities such as air conditioning, faux wood blinds, and a recreational pickleball court. Situated in the vibrant Bluhawk development, residents enjoy abundant shopping and dining while being strategically positioned near major travel routes leading to the airport. Choose The Residences at Bluhawk for a convenient and upscale lifestyle close to your travel needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with parking lot at sunset",
        "public_id": "019fc98c-ec95-7054-86ad-e9993e3804ec",
        "storage_key": "property/6767906449167619/019fc98c-ec95-7054-86ad-e9993e3804ec.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Discover travel-friendly living at The Residences at Bluhawk, offering apartments near Kansas City International Airport. Enjoy comfort and convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701893657"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZDGRRRW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 5"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/3ac8914f-ae31-4dca-97d5-73f074dca103/app.js?nocache=1&gaTracking=G-VLGXE47GM4&buttonbgcolor=b8cecc&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Residences%20at%20Bluhawk/61046?source=community_link"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-349-7560"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNPelFGSHlacEhNSHpyRGI2dVFvZmc9PSIsInZhbHVlIjoiLzJGTmU5aDZzTFVPV1VEZ2c0L0ZDZz09IiwibWFjIjoiZGY5MDJhMDc2MDA1M2FhNzhhYjJhNzNhZWIyNjk0ODBlYTc2OTBjMzM5YzVkNzVhY2M3YTI3MTIwYzYyMmRiOCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701893657",
  "custom_google_gtm_id": "GTM-TZDGRRRW",
  "custom_rollout_phase": "Batch 5",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/3ac8914f-ae31-4dca-97d5-73f074dca103/app.js?nocache=1&gaTracking=G-VLGXE47GM4&buttonbgcolor=b8cecc&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Residences%20at%20Bluhawk/61046?source=community_link",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-349-7560",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNPelFGSHlacEhNSHpyRGI2dVFvZmc9PSIsInZhbHVlIjoiLzJGTmU5aDZzTFVPV1VEZ2c0L0ZDZz09IiwibWFjIjoiZGY5MDJhMDc2MDA1M2FhNzhhYjJhNzNhZWIyNjk0ODBlYTc2OTBjMzM5YzVkNzVhY2M3YTI3MTIwYzYyMmRiOCJ9",
  "custom_audioeye_site_id": "3af26aa6-6e96-40e5-b551-c647551f4b1b",
  "custom_audioeye_site_hash": "d342f29da59e02724397c748abac2024"
};

export const generatedAt = '2026-11-03T22:58:20.575Z';
